// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VolleyballTournamentSoftwareRouteImport } from './routes/volleyball-tournament-software'
import { Route as VolleyballLeagueSoftwareRouteImport } from './routes/volleyball-league-software'
import { Route as TournamentManagementSoftwareRouteImport } from './routes/tournament-management-software'
import { Route as TournamentFormatsRouteImport } from './routes/tournament-formats'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TennisTournamentSoftwareRouteImport } from './routes/tennis-tournament-software'
import { Route as TennisLeagueSoftwareRouteImport } from './routes/tennis-league-software'
import { Route as SwissSystemTournamentGeneratorRouteImport } from './routes/swiss-system-tournament-generator'
import { Route as SquashTournamentSoftwareRouteImport } from './routes/squash-tournament-software'
import { Route as SquashLeagueSoftwareRouteImport } from './routes/squash-league-software'
import { Route as SportsTournamentManagementSoftwareRouteImport } from './routes/sports-tournament-management-software'
import { Route as SportsLeagueManagementSoftwareRouteImport } from './routes/sports-league-management-software'
import { Route as SportsAnalyticsSoftwareForClubsRouteImport } from './routes/sports-analytics-software-for-clubs'
import { Route as SingleEliminationBracketGeneratorRouteImport } from './routes/single-elimination-bracket-generator'
import { Route as ScorepalQuizRouteImport } from './routes/scorepal-quiz'
import { Route as SalesfunnelRouteImport } from './routes/salesfunnel'
import { Route as SalesRouteImport } from './routes/sales'
import { Route as RoundnetTournamentSoftwareRouteImport } from './routes/roundnet-tournament-software'
import { Route as RoundnetLeagueSoftwareRouteImport } from './routes/roundnet-league-software'
import { Route as RoundRobinTournamentGeneratorRouteImport } from './routes/round-robin-tournament-generator'
import { Route as QuizLegacyRouteImport } from './routes/quiz-legacy'
import { Route as QuizCommunityRouteImport } from './routes/quiz-community'
import { Route as QuizRouteImport } from './routes/quiz'
import { Route as PrivacyLegacyRouteImport } from './routes/privacy-legacy'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PricingV2RouteImport } from './routes/pricing-v2'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PickleballTournamentSoftwareRouteImport } from './routes/pickleball-tournament-software'
import { Route as PickleballLeagueSoftwareRouteImport } from './routes/pickleball-league-software'
import { Route as PadelTournamentSoftwareRouteImport } from './routes/padel-tournament-software'
import { Route as PadelLeagueSoftwareRouteImport } from './routes/padel-league-software'
import { Route as OldLandingRouteImport } from './routes/old-landing'
import { Route as MexicanoTournamentGeneratorRouteImport } from './routes/mexicano-tournament-generator'
import { Route as LiveScoringRouteImport } from './routes/live-scoring'
import { Route as ListTournamentRouteImport } from './routes/list-tournament'
import { Route as ListClubRouteImport } from './routes/list-club'
import { Route as LeagueFormatsRouteImport } from './routes/league-formats'
import { Route as LadderLeagueGeneratorRouteImport } from './routes/ladder-league-generator'
import { Route as KingOfTheCourtGeneratorRouteImport } from './routes/king-of-the-court-generator'
import { Route as GroupAndKnockoutGeneratorRouteImport } from './routes/group-and-knockout-generator'
import { Route as ForPlayersRouteImport } from './routes/for-players'
import { Route as ForCommunitiesRouteImport } from './routes/for-communities'
import { Route as ForClubsRouteImport } from './routes/for-clubs'
import { Route as FootballTournamentSoftwareRouteImport } from './routes/football-tournament-software'
import { Route as FootballLeagueSoftwareRouteImport } from './routes/football-league-software'
import { Route as FinishProfileRouteImport } from './routes/finish-profile'
import { Route as FindTournamentsRouteImport } from './routes/find-tournaments'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as EventQuizV2RouteImport } from './routes/event-quiz-v2'
import { Route as EventQuizRouteImport } from './routes/event-quiz'
import { Route as EsportsTournamentSoftwareRouteImport } from './routes/esports-tournament-software'
import { Route as EsportsLeagueSoftwareRouteImport } from './routes/esports-league-software'
import { Route as DoubleEliminationBracketGeneratorRouteImport } from './routes/double-elimination-bracket-generator'
import { Route as DocumentationRouteImport } from './routes/documentation'
import { Route as DisclaimerRouteImport } from './routes/disclaimer'
import { Route as CreateBracketsRouteImport } from './routes/create-brackets'
import { Route as CopyCodeRouteImport } from './routes/copy-code'
import { Route as CookiePolicyRouteImport } from './routes/cookie-policy'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ConnectWhatsappRouteImport } from './routes/connect-whatsapp'
import { Route as ConfirmEmailRouteImport } from './routes/confirm-email'
import { Route as ClubDirectoryRouteImport } from './routes/club-directory'
import { Route as ClaimRouteImport } from './routes/claim'
import { Route as BuildRouteImport } from './routes/build'
import { Route as BasketballTournamentSoftwareRouteImport } from './routes/basketball-tournament-software'
import { Route as BasketballLeagueSoftwareRouteImport } from './routes/basketball-league-software'
import { Route as BadmintonTournamentSoftwareRouteImport } from './routes/badminton-tournament-software'
import { Route as AmericanoMixerRouteImport } from './routes/americano-mixer'
import { Route as AmericanoGeneratorRouteImport } from './routes/americano-generator'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AppRouteImport } from './routes/_app'
import { Route as Club_slugRouteImport } from './routes/$club_slug'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SignupIndexRouteImport } from './routes/signup/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as LeaderboardsIndexRouteImport } from './routes/leaderboards/index'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as StartFromGeneratorRouteImport } from './routes/start.from-generator'
import { Route as SignupThankYouRouteImport } from './routes/signup/thank-you'
import { Route as SignupSignup_typeRouteImport } from './routes/signup/$signup_type'
import { Route as SchedTokenRouteImport } from './routes/sched.$token'
import { Route as SCodeRouteImport } from './routes/s.$code'
import { Route as ReturnSessionPaymentRouteImport } from './routes/return/session-payment'
import { Route as ReturnSubpageRouteImport } from './routes/return/$subpage'
import { Route as RaceHandleRouteImport } from './routes/race.$handle'
import { Route as RReferrals_codeRouteImport } from './routes/r.$referrals_code'
import { Route as OverlayTokenRouteImport } from './routes/overlay.$token'
import { Route as LoginSubpageRouteImport } from './routes/login/$subpage'
import { Route as LeaderboardsPlayersRouteImport } from './routes/leaderboards/players'
import { Route as LeaderboardsLeaguesRouteImport } from './routes/leaderboards/leagues'
import { Route as JoinTeamTokenRouteImport } from './routes/join-team.$token'
import { Route as HelpStreamingOverlayRouteImport } from './routes/help.streaming-overlay'
import { Route as EventUidRouteImport } from './routes/event.$uid'
import { Route as EUidRouteImport } from './routes/e.$uid'
import { Route as ClubClub_slugRouteImport } from './routes/club.$club_slug'
import { Route as ClubInviteTokenRouteImport } from './routes/club-invite.$token'
import { Route as BlogPost_slugRouteImport } from './routes/blog/$post_slug'
import { Route as AdminInviteTokenRouteImport } from './routes/admin-invite.$token'
import { Route as QuizActivateRouteImport } from './routes/quiz.activate'
import { Route as AppTournamentsChoiceRouteImport } from './routes/_app/tournaments-choice'
import { Route as AppTierJourneyRouteImport } from './routes/_app/tier-journey'
import { Route as AppSocialGamesRouteImport } from './routes/_app/social-games'
import { Route as AppManagedEventsRouteImport } from './routes/_app/managed-events'
import { Route as AppGlobalRankingLeagueRouteImport } from './routes/_app/global-ranking-league'
import { Route as AppComingSoonRouteImport } from './routes/_app/coming-soon'
import { Route as AppBillingRouteImport } from './routes/_app/billing'
import { Route as PayMatchFeeTokenRouteImport } from './routes/pay.match-fee.$token'
import { Route as LiveTournamentsTournament_uidRouteImport } from './routes/live/tournaments.$tournament_uid'
import { Route as LiveTTournament_uidRouteImport } from './routes/live/t.$tournament_uid'
import { Route as LiveRyderCupRyder_cup_uidRouteImport } from './routes/live/ryder-cup.$ryder_cup_uid'
import { Route as LiveRcRyder_cup_uidRouteImport } from './routes/live/rc.$ryder_cup_uid'
import { Route as LiveLeaguesLeague_uidRouteImport } from './routes/live/leagues.$league_uid'
import { Route as LiveLeaderboardClub_uidRouteImport } from './routes/live/leaderboard.$club_uid'
import { Route as LiveLLeague_uidRouteImport } from './routes/live/l.$league_uid'
import { Route as LiveKotcKotc_uidRouteImport } from './routes/live/kotc.$kotc_uid'
import { Route as LiveKKotc_uidRouteImport } from './routes/live/k.$kotc_uid'
import { Route as LiveCotUidRouteImport } from './routes/live/cot.$uid'
import { Route as LiveClashOfTeamsUidRouteImport } from './routes/live/clash-of-teams.$uid'
import { Route as JoinEvent_uidTokenRouteImport } from './routes/join.$event_uid.$token'
import { Route as EmbedTournamentsUidRouteImport } from './routes/embed/tournaments.$uid'
import { Route as EmbedRacesHandleRouteImport } from './routes/embed/races.$handle'
import { Route as EmbedLeaguesUidRouteImport } from './routes/embed/leagues.$uid'
import { Route as EUidRegisterRouteImport } from './routes/e.$uid_.register'
import { Route as BookCourtInviteTokenRouteImport } from './routes/book-court/invite.$token'
import { Route as BlogPagePage_numberRouteImport } from './routes/blog/page/$page_number'
import { Route as AppVolleyballIndexRouteImport } from './routes/_app/volleyball/index'
import { Route as AppTournamentsIndexRouteImport } from './routes/_app/tournaments/index'
import { Route as AppTournamentsRankingIndexRouteImport } from './routes/_app/tournaments-ranking/index'
import { Route as AppTournamentsRankingTablesIndexRouteImport } from './routes/_app/tournaments-ranking-tables/index'
import { Route as AppSessionsIndexRouteImport } from './routes/_app/sessions/index'
import { Route as AppRydercupIndexRouteImport } from './routes/_app/rydercup/index'
import { Route as AppRunningIndexRouteImport } from './routes/_app/running/index'
import { Route as AppRoundnetIndexRouteImport } from './routes/_app/roundnet/index'
import { Route as AppPlayersIndexRouteImport } from './routes/_app/players/index'
import { Route as AppMexicanosIndexRouteImport } from './routes/_app/mexicanos/index'
import { Route as AppMessagesIndexRouteImport } from './routes/_app/messages/index'
import { Route as AppMarketplaceIndexRouteImport } from './routes/_app/marketplace/index'
import { Route as AppLeaguesIndexRouteImport } from './routes/_app/leagues/index'
import { Route as AppKotcIndexRouteImport } from './routes/_app/kotc/index'
import { Route as AppFriendlyWagersIndexRouteImport } from './routes/_app/friendly-wagers/index'
import { Route as AppFootballIndexRouteImport } from './routes/_app/football/index'
import { Route as AppEsportsIndexRouteImport } from './routes/_app/esports/index'
import { Route as AppEarnIndexRouteImport } from './routes/_app/earn/index'
import { Route as AppCricketIndexRouteImport } from './routes/_app/cricket/index'
import { Route as AppCommunitiesIndexRouteImport } from './routes/_app/communities/index'
import { Route as AppClubsIndexRouteImport } from './routes/_app/clubs/index'
import { Route as AppClashOfTeamsIndexRouteImport } from './routes/_app/clash-of-teams/index'
import { Route as AppCirclesIndexRouteImport } from './routes/_app/circles/index'
import { Route as AppBookCourtIndexRouteImport } from './routes/_app/book-court/index'
import { Route as AppBasketballIndexRouteImport } from './routes/_app/basketball/index'
import { Route as AppAmericanosIndexRouteImport } from './routes/_app/americanos/index'
import { Route as AppAiIndexRouteImport } from './routes/_app/ai/index'
import { Route as AppAbilitiesIndexRouteImport } from './routes/_app/abilities/index'
import { Route as AppTournamentsNewRouteImport } from './routes/_app/tournaments/new'
import { Route as AppTournamentsTournament_uidRouteImport } from './routes/_app/tournaments/$tournament_uid'
import { Route as AppTournamentsRankingRanking_group_uidRouteImport } from './routes/_app/tournaments-ranking/$ranking_group_uid'
import { Route as AppTournamentsRankingTablesRanking_group_uidRouteImport } from './routes/_app/tournaments-ranking-tables/$ranking_group_uid'
import { Route as AppRydercupCreateRouteImport } from './routes/_app/rydercup/create'
import { Route as AppRydercupUidRouteImport } from './routes/_app/rydercup/$uid'
import { Route as AppRunningUploadRouteImport } from './routes/_app/running/upload'
import { Route as AppRunningDashboardRouteImport } from './routes/_app/running/dashboard'
import { Route as AppProfilesMeRouteImport } from './routes/_app/profiles/me'
import { Route as AppProfileUpcomingGamesRouteImport } from './routes/_app/profile/upcoming-games'
import { Route as AppProfileRecentMatchesRouteImport } from './routes/_app/profile/recent-matches'
import { Route as AppProfileMessagesRouteImport } from './routes/_app/profile/messages'
import { Route as AppPlayersNewRouteImport } from './routes/_app/players/new'
import { Route as AppPlayersPlayer_uidRouteImport } from './routes/_app/players/$player_uid'
import { Route as AppMexicanosCreateRouteImport } from './routes/_app/mexicanos/create'
import { Route as AppMexicanosMexicano_uidRouteImport } from './routes/_app/mexicanos/$mexicano_uid'
import { Route as AppMasterVenuesRouteImport } from './routes/_app/master/venues'
import { Route as AppMasterUsersRouteImport } from './routes/_app/master/users'
import { Route as AppMasterTransactionsRouteImport } from './routes/_app/master/transactions'
import { Route as AppMasterTournamentPlacementsRouteImport } from './routes/_app/master/tournament-placements'
import { Route as AppMasterSupportRouteImport } from './routes/_app/master/support'
import { Route as AppMasterSubscriptionsRouteImport } from './routes/_app/master/subscriptions'
import { Route as AppMasterScorepalQuizRouteImport } from './routes/_app/master/scorepal-quiz'
import { Route as AppMasterScorecardsRouteImport } from './routes/_app/master/scorecards'
import { Route as AppMasterReferralsRouteImport } from './routes/_app/master/referrals'
import { Route as AppMasterQuizResponsesRouteImport } from './routes/_app/master/quiz-responses'
import { Route as AppMasterPushNotificationsRouteImport } from './routes/_app/master/push-notifications'
import { Route as AppMasterProductsRouteImport } from './routes/_app/master/products'
import { Route as AppMasterPricingLabRouteImport } from './routes/_app/master/pricing-lab'
import { Route as AppMasterPostsRouteImport } from './routes/_app/master/posts'
import { Route as AppMasterPlayersRouteImport } from './routes/_app/master/players'
import { Route as AppMasterEventsRouteImport } from './routes/_app/master/events'
import { Route as AppMasterEventPassFeedbackRouteImport } from './routes/_app/master/event-pass-feedback'
import { Route as AppMasterEmbedsRouteImport } from './routes/_app/master/embeds'
import { Route as AppMasterCoinsRedemptionsRouteImport } from './routes/_app/master/coins-redemptions'
import { Route as AppMasterClubListingsRouteImport } from './routes/_app/master/club-listings'
import { Route as AppMasterClientErrorsRouteImport } from './routes/_app/master/client-errors'
import { Route as AppMasterCampaignsRouteImport } from './routes/_app/master/campaigns'
import { Route as AppMasterAuditsRouteImport } from './routes/_app/master/audits'
import { Route as AppMasterAnalyticsRouteImport } from './routes/_app/master/analytics'
import { Route as AppMasterAiPromptsRouteImport } from './routes/_app/master/ai-prompts'
import { Route as AppMasterActivationRouteImport } from './routes/_app/master/activation'
import { Route as AppMarketplaceCategoryRouteImport } from './routes/_app/marketplace/$category'
import { Route as AppLeaguesLeague_uidRouteImport } from './routes/_app/leagues/$league_uid'
import { Route as AppKotcCreateRouteImport } from './routes/_app/kotc/create'
import { Route as AppKotcKotc_uidRouteImport } from './routes/_app/kotc/$kotc_uid'
import { Route as AppGoPaymentsRouteImport } from './routes/_app/go/payments'
import { Route as AppFriendlyWagersGame_uidRouteImport } from './routes/_app/friendly-wagers/$game_uid'
import { Route as AppFootballSocialRouteImport } from './routes/_app/football/social'
import { Route as AppFootballRecordRouteImport } from './routes/_app/football/record'
import { Route as AppCourtsBookingSplatRouteImport } from './routes/_app/courts-booking/$'
import { Route as AppBookCourtCheckoutRouteImport } from './routes/_app/book-court/checkout'
import { Route as AppAmericanosCreateRouteImport } from './routes/_app/americanos/create'
import { Route as AppAmericanosActivateRouteImport } from './routes/_app/americanos/activate'
import { Route as AppAmericanosAmericano_uidRouteImport } from './routes/_app/americanos/$americano_uid'
import { Route as AppAiAi_uidRouteImport } from './routes/_app/ai/$ai_uid'
import { Route as AppVolleyballTournamentsIndexRouteImport } from './routes/_app/volleyball/tournaments/index'
import { Route as AppVolleyballTeamsIndexRouteImport } from './routes/_app/volleyball/teams/index'
import { Route as AppVolleyballPlayersIndexRouteImport } from './routes/_app/volleyball/players/index'
import { Route as AppVolleyballLeaguesIndexRouteImport } from './routes/_app/volleyball/leagues/index'
import { Route as AppVolleyballDashboardIndexRouteImport } from './routes/_app/volleyball/dashboard/index'
import { Route as AppRunningRacesIndexRouteImport } from './routes/_app/running/races.index'
import { Route as AppRoundnetTournamentsIndexRouteImport } from './routes/_app/roundnet/tournaments/index'
import { Route as AppRoundnetTeamsIndexRouteImport } from './routes/_app/roundnet/teams/index'
import { Route as AppRoundnetPlayersIndexRouteImport } from './routes/_app/roundnet/players/index'
import { Route as AppRoundnetLeaguesIndexRouteImport } from './routes/_app/roundnet/leagues/index'
import { Route as AppRoundnetDashboardIndexRouteImport } from './routes/_app/roundnet/dashboard/index'
import { Route as AppProfilesPlayer_uidIndexRouteImport } from './routes/_app/profiles/$player_uid/index'
import { Route as AppOrganizerCoachesIndexRouteImport } from './routes/_app/organizer/coaches/index'
import { Route as AppOrganizerAssessmentsIndexRouteImport } from './routes/_app/organizer/assessments/index'
import { Route as AppFootballTournamentsIndexRouteImport } from './routes/_app/football/tournaments/index'
import { Route as AppFootballTeamsIndexRouteImport } from './routes/_app/football/teams/index'
import { Route as AppFootballPlayersIndexRouteImport } from './routes/_app/football/players/index'
import { Route as AppFootballLeaguesIndexRouteImport } from './routes/_app/football/leagues/index'
import { Route as AppFootballDashboardIndexRouteImport } from './routes/_app/football/dashboard/index'
import { Route as AppEsportsTournamentsIndexRouteImport } from './routes/_app/esports/tournaments/index'
import { Route as AppEsportsTeamsIndexRouteImport } from './routes/_app/esports/teams/index'
import { Route as AppEsportsPlayersIndexRouteImport } from './routes/_app/esports/players/index'
import { Route as AppEsportsLeaguesIndexRouteImport } from './routes/_app/esports/leagues/index'
import { Route as AppEsportsDashboardIndexRouteImport } from './routes/_app/esports/dashboard/index'
import { Route as AppCricketTournamentsIndexRouteImport } from './routes/_app/cricket/tournaments/index'
import { Route as AppCricketTeamsIndexRouteImport } from './routes/_app/cricket/teams/index'
import { Route as AppCricketPlayersIndexRouteImport } from './routes/_app/cricket/players/index'
import { Route as AppCricketLeaguesIndexRouteImport } from './routes/_app/cricket/leagues/index'
import { Route as AppCricketDashboardIndexRouteImport } from './routes/_app/cricket/dashboard/index'
import { Route as AppCommunitiesCommunity_uidIndexRouteImport } from './routes/_app/communities/$community_uid/index'
import { Route as AppClubsClub_uidIndexRouteImport } from './routes/_app/clubs/$club_uid/index'
import { Route as AppBasketballTournamentsIndexRouteImport } from './routes/_app/basketball/tournaments/index'
import { Route as AppBasketballTeamsIndexRouteImport } from './routes/_app/basketball/teams/index'
import { Route as AppBasketballPlayersIndexRouteImport } from './routes/_app/basketball/players/index'
import { Route as AppBasketballLeaguesIndexRouteImport } from './routes/_app/basketball/leagues/index'
import { Route as AppBasketballDashboardIndexRouteImport } from './routes/_app/basketball/dashboard/index'
import { Route as AppAbilitiesAssessment_uidIndexRouteImport } from './routes/_app/abilities/$assessment_uid/index'
import { Route as AppVolleyballTournamentsNewRouteImport } from './routes/_app/volleyball/tournaments/new'
import { Route as AppVolleyballTournamentsTournament_uidRouteImport } from './routes/_app/volleyball/tournaments/$tournament_uid'
import { Route as AppVolleyballLeaguesLeague_uidRouteImport } from './routes/_app/volleyball/leagues/$league_uid'
import { Route as AppRunningResultsImport_uidRouteImport } from './routes/_app/running/results.$import_uid'
import { Route as AppRunningRacesRace_uidRouteImport } from './routes/_app/running/races.$race_uid'
import { Route as AppRunningLeaderboardsRanking_group_uidRouteImport } from './routes/_app/running/leaderboards.$ranking_group_uid'
import { Route as AppRunningLeaderboardsResultsRanking_group_uidRouteImport } from './routes/_app/running/leaderboards-results.$ranking_group_uid'
import { Route as AppRoundnetTournamentsNewRouteImport } from './routes/_app/roundnet/tournaments/new'
import { Route as AppRoundnetTournamentsTournament_uidRouteImport } from './routes/_app/roundnet/tournaments/$tournament_uid'
import { Route as AppRoundnetLeaguesLeague_uidRouteImport } from './routes/_app/roundnet/leagues/$league_uid'
import { Route as AppProfilesPlayer_uidWalletRouteImport } from './routes/_app/profiles/$player_uid/wallet'
import { Route as AppProfilesPlayer_uidStatsRouteImport } from './routes/_app/profiles/$player_uid/stats'
import { Route as AppProfilesPlayer_uidReferralsRouteImport } from './routes/_app/profiles/$player_uid/referrals'
import { Route as AppProfilesPlayer_uidEditRouteImport } from './routes/_app/profiles/$player_uid/edit'
import { Route as AppProfilesPlayer_uidDashboardRouteImport } from './routes/_app/profiles/$player_uid/dashboard'
import { Route as AppProfileGamesGame_uidRouteImport } from './routes/_app/profile/games.$game_uid'
import { Route as AppOrganizerCoachesCoach_uidRouteImport } from './routes/_app/organizer/coaches/$coach_uid'
import { Route as AppMarketplaceGamesGame_uidRouteImport } from './routes/_app/marketplace/games.$game_uid'
import { Route as AppMarketplaceEditGame_uidRouteImport } from './routes/_app/marketplace/edit.$game_uid'
import { Route as AppMarketplaceCheckoutGame_uidRouteImport } from './routes/_app/marketplace/checkout.$game_uid'
import { Route as AppFriendlyWagersSummaryGame_uidRouteImport } from './routes/_app/friendly-wagers/summary.$game_uid'
import { Route as AppFootballTournamentsNewRouteImport } from './routes/_app/football/tournaments/new'
import { Route as AppFootballTournamentsTournament_uidRouteImport } from './routes/_app/football/tournaments/$tournament_uid'
import { Route as AppFootballLeaguesLeague_uidRouteImport } from './routes/_app/football/leagues/$league_uid'
import { Route as AppEsportsTournamentsNewRouteImport } from './routes/_app/esports/tournaments/new'
import { Route as AppEsportsTournamentsTournament_uidRouteImport } from './routes/_app/esports/tournaments/$tournament_uid'
import { Route as AppEsportsLeaguesLeague_uidRouteImport } from './routes/_app/esports/leagues/$league_uid'
import { Route as AppCricketTournamentsNewRouteImport } from './routes/_app/cricket/tournaments/new'
import { Route as AppCricketTournamentsTournament_uidRouteImport } from './routes/_app/cricket/tournaments/$tournament_uid'
import { Route as AppCricketLeaguesLeague_uidRouteImport } from './routes/_app/cricket/leagues/$league_uid'
import { Route as AppCommunitiesCommunity_uidOverviewRouteImport } from './routes/_app/communities/$community_uid/overview'
import { Route as AppCommunitiesCommunity_uidEditRouteImport } from './routes/_app/communities/$community_uid/edit'
import { Route as AppCommunitiesCommunity_uidDashboardRouteImport } from './routes/_app/communities/$community_uid/dashboard'
import { Route as AppClubsClub_uidWagerLeaderboardRouteImport } from './routes/_app/clubs/$club_uid/wager-leaderboard'
import { Route as AppClubsClub_uidReviewsRouteImport } from './routes/_app/clubs/$club_uid/reviews'
import { Route as AppClubsClub_uidOverviewRouteImport } from './routes/_app/clubs/$club_uid/overview'
import { Route as AppClubsClub_uidManageRouteImport } from './routes/_app/clubs/$club_uid/manage'
import { Route as AppClubsClub_uidLeaderboardRouteImport } from './routes/_app/clubs/$club_uid/leaderboard'
import { Route as AppClubsClub_uidFriendlyWagersRouteImport } from './routes/_app/clubs/$club_uid/friendly-wagers'
import { Route as AppClubsClub_uidEditRouteImport } from './routes/_app/clubs/$club_uid/edit'
import { Route as AppClubsClub_uidDashboardRouteImport } from './routes/_app/clubs/$club_uid/dashboard'
import { Route as AppClubsClub_uidCourtsBookingRouteImport } from './routes/_app/clubs/$club_uid/courts-booking'
import { Route as AppClubsClub_uidCourtSetupRouteImport } from './routes/_app/clubs/$club_uid/court-setup'
import { Route as AppClubsClub_uidBookingsRouteImport } from './routes/_app/clubs/$club_uid/bookings'
import { Route as AppClubsClub_uidBillingRouteImport } from './routes/_app/clubs/$club_uid/billing'
import { Route as AppClashOfTeamsUidPageRouteImport } from './routes/_app/clash-of-teams/$uid.$page'
import { Route as AppBasketballTournamentsNewRouteImport } from './routes/_app/basketball/tournaments/new'
import { Route as AppBasketballTournamentsTournament_uidRouteImport } from './routes/_app/basketball/tournaments/$tournament_uid'
import { Route as AppBasketballLeaguesLeague_uidRouteImport } from './routes/_app/basketball/leagues/$league_uid'
import { Route as AppTournamentsTournament_uidPageRouteImport } from './routes/_app/tournaments/$tournament_uid.$page'
import { Route as AppRydercupUidPageRouteImport } from './routes/_app/rydercup/$uid.$page'
import { Route as AppMexicanosMexicano_uidPageRouteImport } from './routes/_app/mexicanos/$mexicano_uid.$page'
import { Route as AppMasterUsersUser_uidRouteImport } from './routes/_app/master/users.$user_uid'
import { Route as AppMasterSubscriptionsPost_uidRouteImport } from './routes/_app/master/subscriptions.$post_uid'
import { Route as AppMasterPostsPost_uidRouteImport } from './routes/_app/master/posts.$post_uid'
import { Route as AppMasterPlayersPlayer_uidRouteImport } from './routes/_app/master/players.$player_uid'
import { Route as AppLeaguesLeague_uidPageRouteImport } from './routes/_app/leagues/$league_uid.$page'
import { Route as AppKotcKotc_uidPageRouteImport } from './routes/_app/kotc/$kotc_uid.$page'
import { Route as AppAmericanosAmericano_uidPageRouteImport } from './routes/_app/americanos/$americano_uid.$page'
import { Route as AppVolleyballTournamentsTournament_uidPageRouteImport } from './routes/_app/volleyball/tournaments/$tournament_uid.$page'
import { Route as AppVolleyballLeaguesLeague_uidPageRouteImport } from './routes/_app/volleyball/leagues/$league_uid.$page'
import { Route as AppRoundnetTournamentsTournament_uidPageRouteImport } from './routes/_app/roundnet/tournaments/$tournament_uid.$page'
import { Route as AppRoundnetLeaguesLeague_uidPageRouteImport } from './routes/_app/roundnet/leagues/$league_uid.$page'
import { Route as AppFootballTournamentsTournament_uidPageRouteImport } from './routes/_app/football/tournaments/$tournament_uid.$page'
import { Route as AppFootballLeaguesLeague_uidPageRouteImport } from './routes/_app/football/leagues/$league_uid.$page'
import { Route as AppEsportsTournamentsTournament_uidPageRouteImport } from './routes/_app/esports/tournaments/$tournament_uid.$page'
import { Route as AppEsportsLeaguesLeague_uidPageRouteImport } from './routes/_app/esports/leagues/$league_uid.$page'
import { Route as AppCricketTournamentsTournament_uidPageRouteImport } from './routes/_app/cricket/tournaments/$tournament_uid.$page'
import { Route as AppCricketLeaguesLeague_uidPageRouteImport } from './routes/_app/cricket/leagues/$league_uid.$page'
import { Route as AppBasketballTournamentsTournament_uidPageRouteImport } from './routes/_app/basketball/tournaments/$tournament_uid.$page'
import { Route as AppBasketballLeaguesLeague_uidPageRouteImport } from './routes/_app/basketball/leagues/$league_uid.$page'
import { Route as AppTournamentsTournament_uidPageSubpageRouteImport } from './routes/_app/tournaments/$tournament_uid.$page.$subpage'
import { Route as AppRydercupUidRoundRoundNumberRouteImport } from './routes/_app/rydercup/$uid.round.$roundNumber'
import { Route as AppLeaguesLeague_uidPlayerPlayer_uidRouteImport } from './routes/_app/leagues/$league_uid.player.$player_uid'
import { Route as AppLeaguesLeague_uidGameGame_uidRouteImport } from './routes/_app/leagues/$league_uid.game.$game_uid'
import { Route as AppLeaguesLeague_uidPageSubpageRouteImport } from './routes/_app/leagues/$league_uid.$page.$subpage'
import { Route as AppVolleyballTournamentsTournament_uidPageSubpageRouteImport } from './routes/_app/volleyball/tournaments/$tournament_uid.$page.$subpage'
import { Route as AppVolleyballLeaguesLeague_uidGameGame_uidRouteImport } from './routes/_app/volleyball/leagues/$league_uid.game.$game_uid'
import { Route as AppVolleyballLeaguesLeague_uidPageSubpageRouteImport } from './routes/_app/volleyball/leagues/$league_uid.$page.$subpage'
import { Route as AppRoundnetTournamentsTournament_uidPageSubpageRouteImport } from './routes/_app/roundnet/tournaments/$tournament_uid.$page.$subpage'
import { Route as AppRoundnetLeaguesLeague_uidGameGame_uidRouteImport } from './routes/_app/roundnet/leagues/$league_uid.game.$game_uid'
import { Route as AppRoundnetLeaguesLeague_uidPageSubpageRouteImport } from './routes/_app/roundnet/leagues/$league_uid.$page.$subpage'
import { Route as AppFootballTournamentsTournament_uidPageSubpageRouteImport } from './routes/_app/football/tournaments/$tournament_uid.$page.$subpage'
import { Route as AppFootballLeaguesLeague_uidGameGame_uidRouteImport } from './routes/_app/football/leagues/$league_uid.game.$game_uid'
import { Route as AppFootballLeaguesLeague_uidPageSubpageRouteImport } from './routes/_app/football/leagues/$league_uid.$page.$subpage'
import { Route as AppEsportsTournamentsTournament_uidPageSubpageRouteImport } from './routes/_app/esports/tournaments/$tournament_uid.$page.$subpage'
import { Route as AppEsportsLeaguesLeague_uidGameGame_uidRouteImport } from './routes/_app/esports/leagues/$league_uid.game.$game_uid'
import { Route as AppEsportsLeaguesLeague_uidPageSubpageRouteImport } from './routes/_app/esports/leagues/$league_uid.$page.$subpage'
import { Route as AppCricketTournamentsTournament_uidPageSubpageRouteImport } from './routes/_app/cricket/tournaments/$tournament_uid.$page.$subpage'
import { Route as AppCricketLeaguesLeague_uidGameGame_uidRouteImport } from './routes/_app/cricket/leagues/$league_uid.game.$game_uid'
import { Route as AppCricketLeaguesLeague_uidPageSubpageRouteImport } from './routes/_app/cricket/leagues/$league_uid.$page.$subpage'
import { Route as AppBasketballTournamentsTournament_uidPageSubpageRouteImport } from './routes/_app/basketball/tournaments/$tournament_uid.$page.$subpage'
import { Route as AppBasketballLeaguesLeague_uidGameGame_uidRouteImport } from './routes/_app/basketball/leagues/$league_uid.game.$game_uid'
import { Route as AppBasketballLeaguesLeague_uidPageSubpageRouteImport } from './routes/_app/basketball/leagues/$league_uid.$page.$subpage'
import { Route as PublicTournamentsTournament_uidApplicationsApplication_uidPayEntryFeeRouteImport } from './routes/public/tournaments.$tournament_uid.applications.$application_uid.pay-entry-fee.'
import { Route as PublicLeaguesLeague_uidApplicationsApplication_uidPayEntryFeeRouteImport } from './routes/public/leagues.$league_uid.applications.$application_uid.pay-entry-fee.'

const VolleyballTournamentSoftwareRoute = VolleyballTournamentSoftwareRouteImport.update({
            id: '/volleyball-tournament-software',path: '/volleyball-tournament-software',getParentRoute: () => rootRouteImport
          })
const VolleyballLeagueSoftwareRoute = VolleyballLeagueSoftwareRouteImport.update({
            id: '/volleyball-league-software',path: '/volleyball-league-software',getParentRoute: () => rootRouteImport
          })
const TournamentManagementSoftwareRoute = TournamentManagementSoftwareRouteImport.update({
            id: '/tournament-management-software',path: '/tournament-management-software',getParentRoute: () => rootRouteImport
          })
const TournamentFormatsRoute = TournamentFormatsRouteImport.update({
            id: '/tournament-formats',path: '/tournament-formats',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const TennisTournamentSoftwareRoute = TennisTournamentSoftwareRouteImport.update({
            id: '/tennis-tournament-software',path: '/tennis-tournament-software',getParentRoute: () => rootRouteImport
          })
const TennisLeagueSoftwareRoute = TennisLeagueSoftwareRouteImport.update({
            id: '/tennis-league-software',path: '/tennis-league-software',getParentRoute: () => rootRouteImport
          })
const SwissSystemTournamentGeneratorRoute = SwissSystemTournamentGeneratorRouteImport.update({
            id: '/swiss-system-tournament-generator',path: '/swiss-system-tournament-generator',getParentRoute: () => rootRouteImport
          })
const SquashTournamentSoftwareRoute = SquashTournamentSoftwareRouteImport.update({
            id: '/squash-tournament-software',path: '/squash-tournament-software',getParentRoute: () => rootRouteImport
          })
const SquashLeagueSoftwareRoute = SquashLeagueSoftwareRouteImport.update({
            id: '/squash-league-software',path: '/squash-league-software',getParentRoute: () => rootRouteImport
          })
const SportsTournamentManagementSoftwareRoute = SportsTournamentManagementSoftwareRouteImport.update({
            id: '/sports-tournament-management-software',path: '/sports-tournament-management-software',getParentRoute: () => rootRouteImport
          })
const SportsLeagueManagementSoftwareRoute = SportsLeagueManagementSoftwareRouteImport.update({
            id: '/sports-league-management-software',path: '/sports-league-management-software',getParentRoute: () => rootRouteImport
          })
const SportsAnalyticsSoftwareForClubsRoute = SportsAnalyticsSoftwareForClubsRouteImport.update({
            id: '/sports-analytics-software-for-clubs',path: '/sports-analytics-software-for-clubs',getParentRoute: () => rootRouteImport
          })
const SingleEliminationBracketGeneratorRoute = SingleEliminationBracketGeneratorRouteImport.update({
            id: '/single-elimination-bracket-generator',path: '/single-elimination-bracket-generator',getParentRoute: () => rootRouteImport
          })
const ScorepalQuizRoute = ScorepalQuizRouteImport.update({
            id: '/scorepal-quiz',path: '/scorepal-quiz',getParentRoute: () => rootRouteImport
          })
const SalesfunnelRoute = SalesfunnelRouteImport.update({
            id: '/salesfunnel',path: '/salesfunnel',getParentRoute: () => rootRouteImport
          })
const SalesRoute = SalesRouteImport.update({
            id: '/sales',path: '/sales',getParentRoute: () => rootRouteImport
          })
const RoundnetTournamentSoftwareRoute = RoundnetTournamentSoftwareRouteImport.update({
            id: '/roundnet-tournament-software',path: '/roundnet-tournament-software',getParentRoute: () => rootRouteImport
          })
const RoundnetLeagueSoftwareRoute = RoundnetLeagueSoftwareRouteImport.update({
            id: '/roundnet-league-software',path: '/roundnet-league-software',getParentRoute: () => rootRouteImport
          })
const RoundRobinTournamentGeneratorRoute = RoundRobinTournamentGeneratorRouteImport.update({
            id: '/round-robin-tournament-generator',path: '/round-robin-tournament-generator',getParentRoute: () => rootRouteImport
          })
const QuizLegacyRoute = QuizLegacyRouteImport.update({
            id: '/quiz-legacy',path: '/quiz-legacy',getParentRoute: () => rootRouteImport
          })
const QuizCommunityRoute = QuizCommunityRouteImport.update({
            id: '/quiz-community',path: '/quiz-community',getParentRoute: () => rootRouteImport
          })
const QuizRoute = QuizRouteImport.update({
            id: '/quiz',path: '/quiz',getParentRoute: () => rootRouteImport
          })
const PrivacyLegacyRoute = PrivacyLegacyRouteImport.update({
            id: '/privacy-legacy',path: '/privacy-legacy',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PricingV2Route = PricingV2RouteImport.update({
            id: '/pricing-v2',path: '/pricing-v2',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PickleballTournamentSoftwareRoute = PickleballTournamentSoftwareRouteImport.update({
            id: '/pickleball-tournament-software',path: '/pickleball-tournament-software',getParentRoute: () => rootRouteImport
          })
const PickleballLeagueSoftwareRoute = PickleballLeagueSoftwareRouteImport.update({
            id: '/pickleball-league-software',path: '/pickleball-league-software',getParentRoute: () => rootRouteImport
          })
const PadelTournamentSoftwareRoute = PadelTournamentSoftwareRouteImport.update({
            id: '/padel-tournament-software',path: '/padel-tournament-software',getParentRoute: () => rootRouteImport
          })
const PadelLeagueSoftwareRoute = PadelLeagueSoftwareRouteImport.update({
            id: '/padel-league-software',path: '/padel-league-software',getParentRoute: () => rootRouteImport
          })
const OldLandingRoute = OldLandingRouteImport.update({
            id: '/old-landing',path: '/old-landing',getParentRoute: () => rootRouteImport
          })
const MexicanoTournamentGeneratorRoute = MexicanoTournamentGeneratorRouteImport.update({
            id: '/mexicano-tournament-generator',path: '/mexicano-tournament-generator',getParentRoute: () => rootRouteImport
          })
const LiveScoringRoute = LiveScoringRouteImport.update({
            id: '/live-scoring',path: '/live-scoring',getParentRoute: () => rootRouteImport
          })
const ListTournamentRoute = ListTournamentRouteImport.update({
            id: '/list-tournament',path: '/list-tournament',getParentRoute: () => rootRouteImport
          })
const ListClubRoute = ListClubRouteImport.update({
            id: '/list-club',path: '/list-club',getParentRoute: () => rootRouteImport
          })
const LeagueFormatsRoute = LeagueFormatsRouteImport.update({
            id: '/league-formats',path: '/league-formats',getParentRoute: () => rootRouteImport
          })
const LadderLeagueGeneratorRoute = LadderLeagueGeneratorRouteImport.update({
            id: '/ladder-league-generator',path: '/ladder-league-generator',getParentRoute: () => rootRouteImport
          })
const KingOfTheCourtGeneratorRoute = KingOfTheCourtGeneratorRouteImport.update({
            id: '/king-of-the-court-generator',path: '/king-of-the-court-generator',getParentRoute: () => rootRouteImport
          })
const GroupAndKnockoutGeneratorRoute = GroupAndKnockoutGeneratorRouteImport.update({
            id: '/group-and-knockout-generator',path: '/group-and-knockout-generator',getParentRoute: () => rootRouteImport
          })
const ForPlayersRoute = ForPlayersRouteImport.update({
            id: '/for-players',path: '/for-players',getParentRoute: () => rootRouteImport
          })
const ForCommunitiesRoute = ForCommunitiesRouteImport.update({
            id: '/for-communities',path: '/for-communities',getParentRoute: () => rootRouteImport
          })
const ForClubsRoute = ForClubsRouteImport.update({
            id: '/for-clubs',path: '/for-clubs',getParentRoute: () => rootRouteImport
          })
const FootballTournamentSoftwareRoute = FootballTournamentSoftwareRouteImport.update({
            id: '/football-tournament-software',path: '/football-tournament-software',getParentRoute: () => rootRouteImport
          })
const FootballLeagueSoftwareRoute = FootballLeagueSoftwareRouteImport.update({
            id: '/football-league-software',path: '/football-league-software',getParentRoute: () => rootRouteImport
          })
const FinishProfileRoute = FinishProfileRouteImport.update({
            id: '/finish-profile',path: '/finish-profile',getParentRoute: () => rootRouteImport
          })
const FindTournamentsRoute = FindTournamentsRouteImport.update({
            id: '/find-tournaments',path: '/find-tournaments',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const EventQuizV2Route = EventQuizV2RouteImport.update({
            id: '/event-quiz-v2',path: '/event-quiz-v2',getParentRoute: () => rootRouteImport
          })
const EventQuizRoute = EventQuizRouteImport.update({
            id: '/event-quiz',path: '/event-quiz',getParentRoute: () => rootRouteImport
          })
const EsportsTournamentSoftwareRoute = EsportsTournamentSoftwareRouteImport.update({
            id: '/esports-tournament-software',path: '/esports-tournament-software',getParentRoute: () => rootRouteImport
          })
const EsportsLeagueSoftwareRoute = EsportsLeagueSoftwareRouteImport.update({
            id: '/esports-league-software',path: '/esports-league-software',getParentRoute: () => rootRouteImport
          })
const DoubleEliminationBracketGeneratorRoute = DoubleEliminationBracketGeneratorRouteImport.update({
            id: '/double-elimination-bracket-generator',path: '/double-elimination-bracket-generator',getParentRoute: () => rootRouteImport
          })
const DocumentationRoute = DocumentationRouteImport.update({
            id: '/documentation',path: '/documentation',getParentRoute: () => rootRouteImport
          })
const DisclaimerRoute = DisclaimerRouteImport.update({
            id: '/disclaimer',path: '/disclaimer',getParentRoute: () => rootRouteImport
          })
const CreateBracketsRoute = CreateBracketsRouteImport.update({
            id: '/create-brackets',path: '/create-brackets',getParentRoute: () => rootRouteImport
          })
const CopyCodeRoute = CopyCodeRouteImport.update({
            id: '/copy-code',path: '/copy-code',getParentRoute: () => rootRouteImport
          })
const CookiePolicyRoute = CookiePolicyRouteImport.update({
            id: '/cookie-policy',path: '/cookie-policy',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const ConnectWhatsappRoute = ConnectWhatsappRouteImport.update({
            id: '/connect-whatsapp',path: '/connect-whatsapp',getParentRoute: () => rootRouteImport
          })
const ConfirmEmailRoute = ConfirmEmailRouteImport.update({
            id: '/confirm-email',path: '/confirm-email',getParentRoute: () => rootRouteImport
          })
const ClubDirectoryRoute = ClubDirectoryRouteImport.update({
            id: '/club-directory',path: '/club-directory',getParentRoute: () => rootRouteImport
          })
const ClaimRoute = ClaimRouteImport.update({
            id: '/claim',path: '/claim',getParentRoute: () => rootRouteImport
          })
const BuildRoute = BuildRouteImport.update({
            id: '/build',path: '/build',getParentRoute: () => rootRouteImport
          })
const BasketballTournamentSoftwareRoute = BasketballTournamentSoftwareRouteImport.update({
            id: '/basketball-tournament-software',path: '/basketball-tournament-software',getParentRoute: () => rootRouteImport
          })
const BasketballLeagueSoftwareRoute = BasketballLeagueSoftwareRouteImport.update({
            id: '/basketball-league-software',path: '/basketball-league-software',getParentRoute: () => rootRouteImport
          })
const BadmintonTournamentSoftwareRoute = BadmintonTournamentSoftwareRouteImport.update({
            id: '/badminton-tournament-software',path: '/badminton-tournament-software',getParentRoute: () => rootRouteImport
          })
const AmericanoMixerRoute = AmericanoMixerRouteImport.update({
            id: '/americano-mixer',path: '/americano-mixer',getParentRoute: () => rootRouteImport
          })
const AmericanoGeneratorRoute = AmericanoGeneratorRouteImport.update({
            id: '/americano-generator',path: '/americano-generator',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const Club_slugRoute = Club_slugRouteImport.update({
            id: '/$club_slug',path: '/$club_slug',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SignupIndexRoute = SignupIndexRouteImport.update({
            id: '/signup/',path: '/signup/',getParentRoute: () => rootRouteImport
          })
const LoginIndexRoute = LoginIndexRouteImport.update({
            id: '/login/',path: '/login/',getParentRoute: () => rootRouteImport
          })
const LeaderboardsIndexRoute = LeaderboardsIndexRouteImport.update({
            id: '/leaderboards/',path: '/leaderboards/',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const StartFromGeneratorRoute = StartFromGeneratorRouteImport.update({
            id: '/start/from-generator',path: '/start/from-generator',getParentRoute: () => rootRouteImport
          })
const SignupThankYouRoute = SignupThankYouRouteImport.update({
            id: '/signup/thank-you',path: '/signup/thank-you',getParentRoute: () => rootRouteImport
          })
const SignupSignup_typeRoute = SignupSignup_typeRouteImport.update({
            id: '/signup/$signup_type',path: '/signup/$signup_type',getParentRoute: () => rootRouteImport
          })
const SchedTokenRoute = SchedTokenRouteImport.update({
            id: '/sched/$token',path: '/sched/$token',getParentRoute: () => rootRouteImport
          })
const SCodeRoute = SCodeRouteImport.update({
            id: '/s/$code',path: '/s/$code',getParentRoute: () => rootRouteImport
          })
const ReturnSessionPaymentRoute = ReturnSessionPaymentRouteImport.update({
            id: '/return/session-payment',path: '/return/session-payment',getParentRoute: () => rootRouteImport
          })
const ReturnSubpageRoute = ReturnSubpageRouteImport.update({
            id: '/return/$subpage',path: '/return/$subpage',getParentRoute: () => rootRouteImport
          })
const RaceHandleRoute = RaceHandleRouteImport.update({
            id: '/race/$handle',path: '/race/$handle',getParentRoute: () => rootRouteImport
          })
const RReferrals_codeRoute = RReferrals_codeRouteImport.update({
            id: '/r/$referrals_code',path: '/r/$referrals_code',getParentRoute: () => rootRouteImport
          })
const OverlayTokenRoute = OverlayTokenRouteImport.update({
            id: '/overlay/$token',path: '/overlay/$token',getParentRoute: () => rootRouteImport
          })
const LoginSubpageRoute = LoginSubpageRouteImport.update({
            id: '/login/$subpage',path: '/login/$subpage',getParentRoute: () => rootRouteImport
          })
const LeaderboardsPlayersRoute = LeaderboardsPlayersRouteImport.update({
            id: '/leaderboards/players',path: '/leaderboards/players',getParentRoute: () => rootRouteImport
          })
const LeaderboardsLeaguesRoute = LeaderboardsLeaguesRouteImport.update({
            id: '/leaderboards/leagues',path: '/leaderboards/leagues',getParentRoute: () => rootRouteImport
          })
const JoinTeamTokenRoute = JoinTeamTokenRouteImport.update({
            id: '/join-team/$token',path: '/join-team/$token',getParentRoute: () => rootRouteImport
          })
const HelpStreamingOverlayRoute = HelpStreamingOverlayRouteImport.update({
            id: '/help/streaming-overlay',path: '/help/streaming-overlay',getParentRoute: () => rootRouteImport
          })
const EventUidRoute = EventUidRouteImport.update({
            id: '/event/$uid',path: '/event/$uid',getParentRoute: () => rootRouteImport
          })
const EUidRoute = EUidRouteImport.update({
            id: '/e/$uid',path: '/e/$uid',getParentRoute: () => rootRouteImport
          })
const ClubClub_slugRoute = ClubClub_slugRouteImport.update({
            id: '/club/$club_slug',path: '/club/$club_slug',getParentRoute: () => rootRouteImport
          })
const ClubInviteTokenRoute = ClubInviteTokenRouteImport.update({
            id: '/club-invite/$token',path: '/club-invite/$token',getParentRoute: () => rootRouteImport
          })
const BlogPost_slugRoute = BlogPost_slugRouteImport.update({
            id: '/blog/$post_slug',path: '/blog/$post_slug',getParentRoute: () => rootRouteImport
          })
const AdminInviteTokenRoute = AdminInviteTokenRouteImport.update({
            id: '/admin-invite/$token',path: '/admin-invite/$token',getParentRoute: () => rootRouteImport
          })
const QuizActivateRoute = QuizActivateRouteImport.update({
            id: '/activate',path: '/activate',getParentRoute: () => QuizRoute
          })
const AppTournamentsChoiceRoute = AppTournamentsChoiceRouteImport.update({
            id: '/tournaments-choice',path: '/tournaments-choice',getParentRoute: () => AppRoute
          })
const AppTierJourneyRoute = AppTierJourneyRouteImport.update({
            id: '/tier-journey',path: '/tier-journey',getParentRoute: () => AppRoute
          })
const AppSocialGamesRoute = AppSocialGamesRouteImport.update({
            id: '/social-games',path: '/social-games',getParentRoute: () => AppRoute
          })
const AppManagedEventsRoute = AppManagedEventsRouteImport.update({
            id: '/managed-events',path: '/managed-events',getParentRoute: () => AppRoute
          })
const AppGlobalRankingLeagueRoute = AppGlobalRankingLeagueRouteImport.update({
            id: '/global-ranking-league',path: '/global-ranking-league',getParentRoute: () => AppRoute
          })
const AppComingSoonRoute = AppComingSoonRouteImport.update({
            id: '/coming-soon',path: '/coming-soon',getParentRoute: () => AppRoute
          })
const AppBillingRoute = AppBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => AppRoute
          })
const PayMatchFeeTokenRoute = PayMatchFeeTokenRouteImport.update({
            id: '/pay/match-fee/$token',path: '/pay/match-fee/$token',getParentRoute: () => rootRouteImport
          })
const LiveTournamentsTournament_uidRoute = LiveTournamentsTournament_uidRouteImport.update({
            id: '/live/tournaments/$tournament_uid',path: '/live/tournaments/$tournament_uid',getParentRoute: () => rootRouteImport
          })
const LiveTTournament_uidRoute = LiveTTournament_uidRouteImport.update({
            id: '/live/t/$tournament_uid',path: '/live/t/$tournament_uid',getParentRoute: () => rootRouteImport
          })
const LiveRyderCupRyder_cup_uidRoute = LiveRyderCupRyder_cup_uidRouteImport.update({
            id: '/live/ryder-cup/$ryder_cup_uid',path: '/live/ryder-cup/$ryder_cup_uid',getParentRoute: () => rootRouteImport
          })
const LiveRcRyder_cup_uidRoute = LiveRcRyder_cup_uidRouteImport.update({
            id: '/live/rc/$ryder_cup_uid',path: '/live/rc/$ryder_cup_uid',getParentRoute: () => rootRouteImport
          })
const LiveLeaguesLeague_uidRoute = LiveLeaguesLeague_uidRouteImport.update({
            id: '/live/leagues/$league_uid',path: '/live/leagues/$league_uid',getParentRoute: () => rootRouteImport
          })
const LiveLeaderboardClub_uidRoute = LiveLeaderboardClub_uidRouteImport.update({
            id: '/live/leaderboard/$club_uid',path: '/live/leaderboard/$club_uid',getParentRoute: () => rootRouteImport
          })
const LiveLLeague_uidRoute = LiveLLeague_uidRouteImport.update({
            id: '/live/l/$league_uid',path: '/live/l/$league_uid',getParentRoute: () => rootRouteImport
          })
const LiveKotcKotc_uidRoute = LiveKotcKotc_uidRouteImport.update({
            id: '/live/kotc/$kotc_uid',path: '/live/kotc/$kotc_uid',getParentRoute: () => rootRouteImport
          })
const LiveKKotc_uidRoute = LiveKKotc_uidRouteImport.update({
            id: '/live/k/$kotc_uid',path: '/live/k/$kotc_uid',getParentRoute: () => rootRouteImport
          })
const LiveCotUidRoute = LiveCotUidRouteImport.update({
            id: '/live/cot/$uid',path: '/live/cot/$uid',getParentRoute: () => rootRouteImport
          })
const LiveClashOfTeamsUidRoute = LiveClashOfTeamsUidRouteImport.update({
            id: '/live/clash-of-teams/$uid',path: '/live/clash-of-teams/$uid',getParentRoute: () => rootRouteImport
          })
const JoinEvent_uidTokenRoute = JoinEvent_uidTokenRouteImport.update({
            id: '/join/$event_uid/$token',path: '/join/$event_uid/$token',getParentRoute: () => rootRouteImport
          })
const EmbedTournamentsUidRoute = EmbedTournamentsUidRouteImport.update({
            id: '/embed/tournaments/$uid',path: '/embed/tournaments/$uid',getParentRoute: () => rootRouteImport
          })
const EmbedRacesHandleRoute = EmbedRacesHandleRouteImport.update({
            id: '/embed/races/$handle',path: '/embed/races/$handle',getParentRoute: () => rootRouteImport
          })
const EmbedLeaguesUidRoute = EmbedLeaguesUidRouteImport.update({
            id: '/embed/leagues/$uid',path: '/embed/leagues/$uid',getParentRoute: () => rootRouteImport
          })
const EUidRegisterRoute = EUidRegisterRouteImport.update({
            id: '/e/$uid_/register',path: '/e/$uid/register',getParentRoute: () => rootRouteImport
          })
const BookCourtInviteTokenRoute = BookCourtInviteTokenRouteImport.update({
            id: '/book-court/invite/$token',path: '/book-court/invite/$token',getParentRoute: () => rootRouteImport
          })
const BlogPagePage_numberRoute = BlogPagePage_numberRouteImport.update({
            id: '/blog/page/$page_number',path: '/blog/page/$page_number',getParentRoute: () => rootRouteImport
          })
const AppVolleyballIndexRoute = AppVolleyballIndexRouteImport.update({
            id: '/volleyball/',path: '/volleyball/',getParentRoute: () => AppRoute
          })
const AppTournamentsIndexRoute = AppTournamentsIndexRouteImport.update({
            id: '/tournaments/',path: '/tournaments/',getParentRoute: () => AppRoute
          })
const AppTournamentsRankingIndexRoute = AppTournamentsRankingIndexRouteImport.update({
            id: '/tournaments-ranking/',path: '/tournaments-ranking/',getParentRoute: () => AppRoute
          })
const AppTournamentsRankingTablesIndexRoute = AppTournamentsRankingTablesIndexRouteImport.update({
            id: '/tournaments-ranking-tables/',path: '/tournaments-ranking-tables/',getParentRoute: () => AppRoute
          })
const AppSessionsIndexRoute = AppSessionsIndexRouteImport.update({
            id: '/sessions/',path: '/sessions/',getParentRoute: () => AppRoute
          })
const AppRydercupIndexRoute = AppRydercupIndexRouteImport.update({
            id: '/rydercup/',path: '/rydercup/',getParentRoute: () => AppRoute
          })
const AppRunningIndexRoute = AppRunningIndexRouteImport.update({
            id: '/running/',path: '/running/',getParentRoute: () => AppRoute
          })
const AppRoundnetIndexRoute = AppRoundnetIndexRouteImport.update({
            id: '/roundnet/',path: '/roundnet/',getParentRoute: () => AppRoute
          })
const AppPlayersIndexRoute = AppPlayersIndexRouteImport.update({
            id: '/players/',path: '/players/',getParentRoute: () => AppRoute
          })
const AppMexicanosIndexRoute = AppMexicanosIndexRouteImport.update({
            id: '/mexicanos/',path: '/mexicanos/',getParentRoute: () => AppRoute
          })
const AppMessagesIndexRoute = AppMessagesIndexRouteImport.update({
            id: '/messages/',path: '/messages/',getParentRoute: () => AppRoute
          })
const AppMarketplaceIndexRoute = AppMarketplaceIndexRouteImport.update({
            id: '/marketplace/',path: '/marketplace/',getParentRoute: () => AppRoute
          })
const AppLeaguesIndexRoute = AppLeaguesIndexRouteImport.update({
            id: '/leagues/',path: '/leagues/',getParentRoute: () => AppRoute
          })
const AppKotcIndexRoute = AppKotcIndexRouteImport.update({
            id: '/kotc/',path: '/kotc/',getParentRoute: () => AppRoute
          })
const AppFriendlyWagersIndexRoute = AppFriendlyWagersIndexRouteImport.update({
            id: '/friendly-wagers/',path: '/friendly-wagers/',getParentRoute: () => AppRoute
          })
const AppFootballIndexRoute = AppFootballIndexRouteImport.update({
            id: '/football/',path: '/football/',getParentRoute: () => AppRoute
          })
const AppEsportsIndexRoute = AppEsportsIndexRouteImport.update({
            id: '/esports/',path: '/esports/',getParentRoute: () => AppRoute
          })
const AppEarnIndexRoute = AppEarnIndexRouteImport.update({
            id: '/earn/',path: '/earn/',getParentRoute: () => AppRoute
          })
const AppCricketIndexRoute = AppCricketIndexRouteImport.update({
            id: '/cricket/',path: '/cricket/',getParentRoute: () => AppRoute
          })
const AppCommunitiesIndexRoute = AppCommunitiesIndexRouteImport.update({
            id: '/communities/',path: '/communities/',getParentRoute: () => AppRoute
          })
const AppClubsIndexRoute = AppClubsIndexRouteImport.update({
            id: '/clubs/',path: '/clubs/',getParentRoute: () => AppRoute
          })
const AppClashOfTeamsIndexRoute = AppClashOfTeamsIndexRouteImport.update({
            id: '/clash-of-teams/',path: '/clash-of-teams/',getParentRoute: () => AppRoute
          })
const AppCirclesIndexRoute = AppCirclesIndexRouteImport.update({
            id: '/circles/',path: '/circles/',getParentRoute: () => AppRoute
          })
const AppBookCourtIndexRoute = AppBookCourtIndexRouteImport.update({
            id: '/book-court/',path: '/book-court/',getParentRoute: () => AppRoute
          })
const AppBasketballIndexRoute = AppBasketballIndexRouteImport.update({
            id: '/basketball/',path: '/basketball/',getParentRoute: () => AppRoute
          })
const AppAmericanosIndexRoute = AppAmericanosIndexRouteImport.update({
            id: '/americanos/',path: '/americanos/',getParentRoute: () => AppRoute
          })
const AppAiIndexRoute = AppAiIndexRouteImport.update({
            id: '/ai/',path: '/ai/',getParentRoute: () => AppRoute
          })
const AppAbilitiesIndexRoute = AppAbilitiesIndexRouteImport.update({
            id: '/abilities/',path: '/abilities/',getParentRoute: () => AppRoute
          })
const AppTournamentsNewRoute = AppTournamentsNewRouteImport.update({
            id: '/tournaments/new',path: '/tournaments/new',getParentRoute: () => AppRoute
          })
const AppTournamentsTournament_uidRoute = AppTournamentsTournament_uidRouteImport.update({
            id: '/tournaments/$tournament_uid',path: '/tournaments/$tournament_uid',getParentRoute: () => AppRoute
          })
const AppTournamentsRankingRanking_group_uidRoute = AppTournamentsRankingRanking_group_uidRouteImport.update({
            id: '/tournaments-ranking/$ranking_group_uid',path: '/tournaments-ranking/$ranking_group_uid',getParentRoute: () => AppRoute
          })
const AppTournamentsRankingTablesRanking_group_uidRoute = AppTournamentsRankingTablesRanking_group_uidRouteImport.update({
            id: '/tournaments-ranking-tables/$ranking_group_uid',path: '/tournaments-ranking-tables/$ranking_group_uid',getParentRoute: () => AppRoute
          })
const AppRydercupCreateRoute = AppRydercupCreateRouteImport.update({
            id: '/rydercup/create',path: '/rydercup/create',getParentRoute: () => AppRoute
          })
const AppRydercupUidRoute = AppRydercupUidRouteImport.update({
            id: '/rydercup/$uid',path: '/rydercup/$uid',getParentRoute: () => AppRoute
          })
const AppRunningUploadRoute = AppRunningUploadRouteImport.update({
            id: '/running/upload',path: '/running/upload',getParentRoute: () => AppRoute
          })
const AppRunningDashboardRoute = AppRunningDashboardRouteImport.update({
            id: '/running/dashboard',path: '/running/dashboard',getParentRoute: () => AppRoute
          })
const AppProfilesMeRoute = AppProfilesMeRouteImport.update({
            id: '/profiles/me',path: '/profiles/me',getParentRoute: () => AppRoute
          })
const AppProfileUpcomingGamesRoute = AppProfileUpcomingGamesRouteImport.update({
            id: '/profile/upcoming-games',path: '/profile/upcoming-games',getParentRoute: () => AppRoute
          })
const AppProfileRecentMatchesRoute = AppProfileRecentMatchesRouteImport.update({
            id: '/profile/recent-matches',path: '/profile/recent-matches',getParentRoute: () => AppRoute
          })
const AppProfileMessagesRoute = AppProfileMessagesRouteImport.update({
            id: '/profile/messages',path: '/profile/messages',getParentRoute: () => AppRoute
          })
const AppPlayersNewRoute = AppPlayersNewRouteImport.update({
            id: '/players/new',path: '/players/new',getParentRoute: () => AppRoute
          })
const AppPlayersPlayer_uidRoute = AppPlayersPlayer_uidRouteImport.update({
            id: '/players/$player_uid',path: '/players/$player_uid',getParentRoute: () => AppRoute
          })
const AppMexicanosCreateRoute = AppMexicanosCreateRouteImport.update({
            id: '/mexicanos/create',path: '/mexicanos/create',getParentRoute: () => AppRoute
          })
const AppMexicanosMexicano_uidRoute = AppMexicanosMexicano_uidRouteImport.update({
            id: '/mexicanos/$mexicano_uid',path: '/mexicanos/$mexicano_uid',getParentRoute: () => AppRoute
          })
const AppMasterVenuesRoute = AppMasterVenuesRouteImport.update({
            id: '/master/venues',path: '/master/venues',getParentRoute: () => AppRoute
          })
const AppMasterUsersRoute = AppMasterUsersRouteImport.update({
            id: '/master/users',path: '/master/users',getParentRoute: () => AppRoute
          })
const AppMasterTransactionsRoute = AppMasterTransactionsRouteImport.update({
            id: '/master/transactions',path: '/master/transactions',getParentRoute: () => AppRoute
          })
const AppMasterTournamentPlacementsRoute = AppMasterTournamentPlacementsRouteImport.update({
            id: '/master/tournament-placements',path: '/master/tournament-placements',getParentRoute: () => AppRoute
          })
const AppMasterSupportRoute = AppMasterSupportRouteImport.update({
            id: '/master/support',path: '/master/support',getParentRoute: () => AppRoute
          })
const AppMasterSubscriptionsRoute = AppMasterSubscriptionsRouteImport.update({
            id: '/master/subscriptions',path: '/master/subscriptions',getParentRoute: () => AppRoute
          })
const AppMasterScorepalQuizRoute = AppMasterScorepalQuizRouteImport.update({
            id: '/master/scorepal-quiz',path: '/master/scorepal-quiz',getParentRoute: () => AppRoute
          })
const AppMasterScorecardsRoute = AppMasterScorecardsRouteImport.update({
            id: '/master/scorecards',path: '/master/scorecards',getParentRoute: () => AppRoute
          })
const AppMasterReferralsRoute = AppMasterReferralsRouteImport.update({
            id: '/master/referrals',path: '/master/referrals',getParentRoute: () => AppRoute
          })
const AppMasterQuizResponsesRoute = AppMasterQuizResponsesRouteImport.update({
            id: '/master/quiz-responses',path: '/master/quiz-responses',getParentRoute: () => AppRoute
          })
const AppMasterPushNotificationsRoute = AppMasterPushNotificationsRouteImport.update({
            id: '/master/push-notifications',path: '/master/push-notifications',getParentRoute: () => AppRoute
          })
const AppMasterProductsRoute = AppMasterProductsRouteImport.update({
            id: '/master/products',path: '/master/products',getParentRoute: () => AppRoute
          })
const AppMasterPricingLabRoute = AppMasterPricingLabRouteImport.update({
            id: '/master/pricing-lab',path: '/master/pricing-lab',getParentRoute: () => AppRoute
          })
const AppMasterPostsRoute = AppMasterPostsRouteImport.update({
            id: '/master/posts',path: '/master/posts',getParentRoute: () => AppRoute
          })
const AppMasterPlayersRoute = AppMasterPlayersRouteImport.update({
            id: '/master/players',path: '/master/players',getParentRoute: () => AppRoute
          })
const AppMasterEventsRoute = AppMasterEventsRouteImport.update({
            id: '/master/events',path: '/master/events',getParentRoute: () => AppRoute
          })
const AppMasterEventPassFeedbackRoute = AppMasterEventPassFeedbackRouteImport.update({
            id: '/master/event-pass-feedback',path: '/master/event-pass-feedback',getParentRoute: () => AppRoute
          })
const AppMasterEmbedsRoute = AppMasterEmbedsRouteImport.update({
            id: '/master/embeds',path: '/master/embeds',getParentRoute: () => AppRoute
          })
const AppMasterCoinsRedemptionsRoute = AppMasterCoinsRedemptionsRouteImport.update({
            id: '/master/coins-redemptions',path: '/master/coins-redemptions',getParentRoute: () => AppRoute
          })
const AppMasterClubListingsRoute = AppMasterClubListingsRouteImport.update({
            id: '/master/club-listings',path: '/master/club-listings',getParentRoute: () => AppRoute
          })
const AppMasterClientErrorsRoute = AppMasterClientErrorsRouteImport.update({
            id: '/master/client-errors',path: '/master/client-errors',getParentRoute: () => AppRoute
          })
const AppMasterCampaignsRoute = AppMasterCampaignsRouteImport.update({
            id: '/master/campaigns',path: '/master/campaigns',getParentRoute: () => AppRoute
          })
const AppMasterAuditsRoute = AppMasterAuditsRouteImport.update({
            id: '/master/audits',path: '/master/audits',getParentRoute: () => AppRoute
          })
const AppMasterAnalyticsRoute = AppMasterAnalyticsRouteImport.update({
            id: '/master/analytics',path: '/master/analytics',getParentRoute: () => AppRoute
          })
const AppMasterAiPromptsRoute = AppMasterAiPromptsRouteImport.update({
            id: '/master/ai-prompts',path: '/master/ai-prompts',getParentRoute: () => AppRoute
          })
const AppMasterActivationRoute = AppMasterActivationRouteImport.update({
            id: '/master/activation',path: '/master/activation',getParentRoute: () => AppRoute
          })
const AppMarketplaceCategoryRoute = AppMarketplaceCategoryRouteImport.update({
            id: '/marketplace/$category',path: '/marketplace/$category',getParentRoute: () => AppRoute
          })
const AppLeaguesLeague_uidRoute = AppLeaguesLeague_uidRouteImport.update({
            id: '/leagues/$league_uid',path: '/leagues/$league_uid',getParentRoute: () => AppRoute
          })
const AppKotcCreateRoute = AppKotcCreateRouteImport.update({
            id: '/kotc/create',path: '/kotc/create',getParentRoute: () => AppRoute
          })
const AppKotcKotc_uidRoute = AppKotcKotc_uidRouteImport.update({
            id: '/kotc/$kotc_uid',path: '/kotc/$kotc_uid',getParentRoute: () => AppRoute
          })
const AppGoPaymentsRoute = AppGoPaymentsRouteImport.update({
            id: '/go/payments',path: '/go/payments',getParentRoute: () => AppRoute
          })
const AppFriendlyWagersGame_uidRoute = AppFriendlyWagersGame_uidRouteImport.update({
            id: '/friendly-wagers/$game_uid',path: '/friendly-wagers/$game_uid',getParentRoute: () => AppRoute
          })
const AppFootballSocialRoute = AppFootballSocialRouteImport.update({
            id: '/football/social',path: '/football/social',getParentRoute: () => AppRoute
          })
const AppFootballRecordRoute = AppFootballRecordRouteImport.update({
            id: '/football/record',path: '/football/record',getParentRoute: () => AppRoute
          })
const AppCourtsBookingSplatRoute = AppCourtsBookingSplatRouteImport.update({
            id: '/courts-booking/$',path: '/courts-booking/$',getParentRoute: () => AppRoute
          })
const AppBookCourtCheckoutRoute = AppBookCourtCheckoutRouteImport.update({
            id: '/book-court/checkout',path: '/book-court/checkout',getParentRoute: () => AppRoute
          })
const AppAmericanosCreateRoute = AppAmericanosCreateRouteImport.update({
            id: '/americanos/create',path: '/americanos/create',getParentRoute: () => AppRoute
          })
const AppAmericanosActivateRoute = AppAmericanosActivateRouteImport.update({
            id: '/americanos/activate',path: '/americanos/activate',getParentRoute: () => AppRoute
          })
const AppAmericanosAmericano_uidRoute = AppAmericanosAmericano_uidRouteImport.update({
            id: '/americanos/$americano_uid',path: '/americanos/$americano_uid',getParentRoute: () => AppRoute
          })
const AppAiAi_uidRoute = AppAiAi_uidRouteImport.update({
            id: '/ai/$ai_uid',path: '/ai/$ai_uid',getParentRoute: () => AppRoute
          })
const AppVolleyballTournamentsIndexRoute = AppVolleyballTournamentsIndexRouteImport.update({
            id: '/volleyball/tournaments/',path: '/volleyball/tournaments/',getParentRoute: () => AppRoute
          })
const AppVolleyballTeamsIndexRoute = AppVolleyballTeamsIndexRouteImport.update({
            id: '/volleyball/teams/',path: '/volleyball/teams/',getParentRoute: () => AppRoute
          })
const AppVolleyballPlayersIndexRoute = AppVolleyballPlayersIndexRouteImport.update({
            id: '/volleyball/players/',path: '/volleyball/players/',getParentRoute: () => AppRoute
          })
const AppVolleyballLeaguesIndexRoute = AppVolleyballLeaguesIndexRouteImport.update({
            id: '/volleyball/leagues/',path: '/volleyball/leagues/',getParentRoute: () => AppRoute
          })
const AppVolleyballDashboardIndexRoute = AppVolleyballDashboardIndexRouteImport.update({
            id: '/volleyball/dashboard/',path: '/volleyball/dashboard/',getParentRoute: () => AppRoute
          })
const AppRunningRacesIndexRoute = AppRunningRacesIndexRouteImport.update({
            id: '/running/races/',path: '/running/races/',getParentRoute: () => AppRoute
          })
const AppRoundnetTournamentsIndexRoute = AppRoundnetTournamentsIndexRouteImport.update({
            id: '/roundnet/tournaments/',path: '/roundnet/tournaments/',getParentRoute: () => AppRoute
          })
const AppRoundnetTeamsIndexRoute = AppRoundnetTeamsIndexRouteImport.update({
            id: '/roundnet/teams/',path: '/roundnet/teams/',getParentRoute: () => AppRoute
          })
const AppRoundnetPlayersIndexRoute = AppRoundnetPlayersIndexRouteImport.update({
            id: '/roundnet/players/',path: '/roundnet/players/',getParentRoute: () => AppRoute
          })
const AppRoundnetLeaguesIndexRoute = AppRoundnetLeaguesIndexRouteImport.update({
            id: '/roundnet/leagues/',path: '/roundnet/leagues/',getParentRoute: () => AppRoute
          })
const AppRoundnetDashboardIndexRoute = AppRoundnetDashboardIndexRouteImport.update({
            id: '/roundnet/dashboard/',path: '/roundnet/dashboard/',getParentRoute: () => AppRoute
          })
const AppProfilesPlayer_uidIndexRoute = AppProfilesPlayer_uidIndexRouteImport.update({
            id: '/profiles/$player_uid/',path: '/profiles/$player_uid/',getParentRoute: () => AppRoute
          })
const AppOrganizerCoachesIndexRoute = AppOrganizerCoachesIndexRouteImport.update({
            id: '/organizer/coaches/',path: '/organizer/coaches/',getParentRoute: () => AppRoute
          })
const AppOrganizerAssessmentsIndexRoute = AppOrganizerAssessmentsIndexRouteImport.update({
            id: '/organizer/assessments/',path: '/organizer/assessments/',getParentRoute: () => AppRoute
          })
const AppFootballTournamentsIndexRoute = AppFootballTournamentsIndexRouteImport.update({
            id: '/football/tournaments/',path: '/football/tournaments/',getParentRoute: () => AppRoute
          })
const AppFootballTeamsIndexRoute = AppFootballTeamsIndexRouteImport.update({
            id: '/football/teams/',path: '/football/teams/',getParentRoute: () => AppRoute
          })
const AppFootballPlayersIndexRoute = AppFootballPlayersIndexRouteImport.update({
            id: '/football/players/',path: '/football/players/',getParentRoute: () => AppRoute
          })
const AppFootballLeaguesIndexRoute = AppFootballLeaguesIndexRouteImport.update({
            id: '/football/leagues/',path: '/football/leagues/',getParentRoute: () => AppRoute
          })
const AppFootballDashboardIndexRoute = AppFootballDashboardIndexRouteImport.update({
            id: '/football/dashboard/',path: '/football/dashboard/',getParentRoute: () => AppRoute
          })
const AppEsportsTournamentsIndexRoute = AppEsportsTournamentsIndexRouteImport.update({
            id: '/esports/tournaments/',path: '/esports/tournaments/',getParentRoute: () => AppRoute
          })
const AppEsportsTeamsIndexRoute = AppEsportsTeamsIndexRouteImport.update({
            id: '/esports/teams/',path: '/esports/teams/',getParentRoute: () => AppRoute
          })
const AppEsportsPlayersIndexRoute = AppEsportsPlayersIndexRouteImport.update({
            id: '/esports/players/',path: '/esports/players/',getParentRoute: () => AppRoute
          })
const AppEsportsLeaguesIndexRoute = AppEsportsLeaguesIndexRouteImport.update({
            id: '/esports/leagues/',path: '/esports/leagues/',getParentRoute: () => AppRoute
          })
const AppEsportsDashboardIndexRoute = AppEsportsDashboardIndexRouteImport.update({
            id: '/esports/dashboard/',path: '/esports/dashboard/',getParentRoute: () => AppRoute
          })
const AppCricketTournamentsIndexRoute = AppCricketTournamentsIndexRouteImport.update({
            id: '/cricket/tournaments/',path: '/cricket/tournaments/',getParentRoute: () => AppRoute
          })
const AppCricketTeamsIndexRoute = AppCricketTeamsIndexRouteImport.update({
            id: '/cricket/teams/',path: '/cricket/teams/',getParentRoute: () => AppRoute
          })
const AppCricketPlayersIndexRoute = AppCricketPlayersIndexRouteImport.update({
            id: '/cricket/players/',path: '/cricket/players/',getParentRoute: () => AppRoute
          })
const AppCricketLeaguesIndexRoute = AppCricketLeaguesIndexRouteImport.update({
            id: '/cricket/leagues/',path: '/cricket/leagues/',getParentRoute: () => AppRoute
          })
const AppCricketDashboardIndexRoute = AppCricketDashboardIndexRouteImport.update({
            id: '/cricket/dashboard/',path: '/cricket/dashboard/',getParentRoute: () => AppRoute
          })
const AppCommunitiesCommunity_uidIndexRoute = AppCommunitiesCommunity_uidIndexRouteImport.update({
            id: '/communities/$community_uid/',path: '/communities/$community_uid/',getParentRoute: () => AppRoute
          })
const AppClubsClub_uidIndexRoute = AppClubsClub_uidIndexRouteImport.update({
            id: '/clubs/$club_uid/',path: '/clubs/$club_uid/',getParentRoute: () => AppRoute
          })
const AppBasketballTournamentsIndexRoute = AppBasketballTournamentsIndexRouteImport.update({
            id: '/basketball/tournaments/',path: '/basketball/tournaments/',getParentRoute: () => AppRoute
          })
const AppBasketballTeamsIndexRoute = AppBasketballTeamsIndexRouteImport.update({
            id: '/basketball/teams/',path: '/basketball/teams/',getParentRoute: () => AppRoute
          })
const AppBasketballPlayersIndexRoute = AppBasketballPlayersIndexRouteImport.update({
            id: '/basketball/players/',path: '/basketball/players/',getParentRoute: () => AppRoute
          })
const AppBasketballLeaguesIndexRoute = AppBasketballLeaguesIndexRouteImport.update({
            id: '/basketball/leagues/',path: '/basketball/leagues/',getParentRoute: () => AppRoute
          })
const AppBasketballDashboardIndexRoute = AppBasketballDashboardIndexRouteImport.update({
            id: '/basketball/dashboard/',path: '/basketball/dashboard/',getParentRoute: () => AppRoute
          })
const AppAbilitiesAssessment_uidIndexRoute = AppAbilitiesAssessment_uidIndexRouteImport.update({
            id: '/abilities/$assessment_uid/',path: '/abilities/$assessment_uid/',getParentRoute: () => AppRoute
          })
const AppVolleyballTournamentsNewRoute = AppVolleyballTournamentsNewRouteImport.update({
            id: '/volleyball/tournaments/new',path: '/volleyball/tournaments/new',getParentRoute: () => AppRoute
          })
const AppVolleyballTournamentsTournament_uidRoute = AppVolleyballTournamentsTournament_uidRouteImport.update({
            id: '/volleyball/tournaments/$tournament_uid',path: '/volleyball/tournaments/$tournament_uid',getParentRoute: () => AppRoute
          })
const AppVolleyballLeaguesLeague_uidRoute = AppVolleyballLeaguesLeague_uidRouteImport.update({
            id: '/volleyball/leagues/$league_uid',path: '/volleyball/leagues/$league_uid',getParentRoute: () => AppRoute
          })
const AppRunningResultsImport_uidRoute = AppRunningResultsImport_uidRouteImport.update({
            id: '/running/results/$import_uid',path: '/running/results/$import_uid',getParentRoute: () => AppRoute
          })
const AppRunningRacesRace_uidRoute = AppRunningRacesRace_uidRouteImport.update({
            id: '/running/races/$race_uid',path: '/running/races/$race_uid',getParentRoute: () => AppRoute
          })
const AppRunningLeaderboardsRanking_group_uidRoute = AppRunningLeaderboardsRanking_group_uidRouteImport.update({
            id: '/running/leaderboards/$ranking_group_uid',path: '/running/leaderboards/$ranking_group_uid',getParentRoute: () => AppRoute
          })
const AppRunningLeaderboardsResultsRanking_group_uidRoute = AppRunningLeaderboardsResultsRanking_group_uidRouteImport.update({
            id: '/running/leaderboards-results/$ranking_group_uid',path: '/running/leaderboards-results/$ranking_group_uid',getParentRoute: () => AppRoute
          })
const AppRoundnetTournamentsNewRoute = AppRoundnetTournamentsNewRouteImport.update({
            id: '/roundnet/tournaments/new',path: '/roundnet/tournaments/new',getParentRoute: () => AppRoute
          })
const AppRoundnetTournamentsTournament_uidRoute = AppRoundnetTournamentsTournament_uidRouteImport.update({
            id: '/roundnet/tournaments/$tournament_uid',path: '/roundnet/tournaments/$tournament_uid',getParentRoute: () => AppRoute
          })
const AppRoundnetLeaguesLeague_uidRoute = AppRoundnetLeaguesLeague_uidRouteImport.update({
            id: '/roundnet/leagues/$league_uid',path: '/roundnet/leagues/$league_uid',getParentRoute: () => AppRoute
          })
const AppProfilesPlayer_uidWalletRoute = AppProfilesPlayer_uidWalletRouteImport.update({
            id: '/profiles/$player_uid/wallet',path: '/profiles/$player_uid/wallet',getParentRoute: () => AppRoute
          })
const AppProfilesPlayer_uidStatsRoute = AppProfilesPlayer_uidStatsRouteImport.update({
            id: '/profiles/$player_uid/stats',path: '/profiles/$player_uid/stats',getParentRoute: () => AppRoute
          })
const AppProfilesPlayer_uidReferralsRoute = AppProfilesPlayer_uidReferralsRouteImport.update({
            id: '/profiles/$player_uid/referrals',path: '/profiles/$player_uid/referrals',getParentRoute: () => AppRoute
          })
const AppProfilesPlayer_uidEditRoute = AppProfilesPlayer_uidEditRouteImport.update({
            id: '/profiles/$player_uid/edit',path: '/profiles/$player_uid/edit',getParentRoute: () => AppRoute
          })
const AppProfilesPlayer_uidDashboardRoute = AppProfilesPlayer_uidDashboardRouteImport.update({
            id: '/profiles/$player_uid/dashboard',path: '/profiles/$player_uid/dashboard',getParentRoute: () => AppRoute
          })
const AppProfileGamesGame_uidRoute = AppProfileGamesGame_uidRouteImport.update({
            id: '/profile/games/$game_uid',path: '/profile/games/$game_uid',getParentRoute: () => AppRoute
          })
const AppOrganizerCoachesCoach_uidRoute = AppOrganizerCoachesCoach_uidRouteImport.update({
            id: '/organizer/coaches/$coach_uid',path: '/organizer/coaches/$coach_uid',getParentRoute: () => AppRoute
          })
const AppMarketplaceGamesGame_uidRoute = AppMarketplaceGamesGame_uidRouteImport.update({
            id: '/marketplace/games/$game_uid',path: '/marketplace/games/$game_uid',getParentRoute: () => AppRoute
          })
const AppMarketplaceEditGame_uidRoute = AppMarketplaceEditGame_uidRouteImport.update({
            id: '/marketplace/edit/$game_uid',path: '/marketplace/edit/$game_uid',getParentRoute: () => AppRoute
          })
const AppMarketplaceCheckoutGame_uidRoute = AppMarketplaceCheckoutGame_uidRouteImport.update({
            id: '/marketplace/checkout/$game_uid',path: '/marketplace/checkout/$game_uid',getParentRoute: () => AppRoute
          })
const AppFriendlyWagersSummaryGame_uidRoute = AppFriendlyWagersSummaryGame_uidRouteImport.update({
            id: '/friendly-wagers/summary/$game_uid',path: '/friendly-wagers/summary/$game_uid',getParentRoute: () => AppRoute
          })
const AppFootballTournamentsNewRoute = AppFootballTournamentsNewRouteImport.update({
            id: '/football/tournaments/new',path: '/football/tournaments/new',getParentRoute: () => AppRoute
          })
const AppFootballTournamentsTournament_uidRoute = AppFootballTournamentsTournament_uidRouteImport.update({
            id: '/football/tournaments/$tournament_uid',path: '/football/tournaments/$tournament_uid',getParentRoute: () => AppRoute
          })
const AppFootballLeaguesLeague_uidRoute = AppFootballLeaguesLeague_uidRouteImport.update({
            id: '/football/leagues/$league_uid',path: '/football/leagues/$league_uid',getParentRoute: () => AppRoute
          })
const AppEsportsTournamentsNewRoute = AppEsportsTournamentsNewRouteImport.update({
            id: '/esports/tournaments/new',path: '/esports/tournaments/new',getParentRoute: () => AppRoute
          })
const AppEsportsTournamentsTournament_uidRoute = AppEsportsTournamentsTournament_uidRouteImport.update({
            id: '/esports/tournaments/$tournament_uid',path: '/esports/tournaments/$tournament_uid',getParentRoute: () => AppRoute
          })
const AppEsportsLeaguesLeague_uidRoute = AppEsportsLeaguesLeague_uidRouteImport.update({
            id: '/esports/leagues/$league_uid',path: '/esports/leagues/$league_uid',getParentRoute: () => AppRoute
          })
const AppCricketTournamentsNewRoute = AppCricketTournamentsNewRouteImport.update({
            id: '/cricket/tournaments/new',path: '/cricket/tournaments/new',getParentRoute: () => AppRoute
          })
const AppCricketTournamentsTournament_uidRoute = AppCricketTournamentsTournament_uidRouteImport.update({
            id: '/cricket/tournaments/$tournament_uid',path: '/cricket/tournaments/$tournament_uid',getParentRoute: () => AppRoute
          })
const AppCricketLeaguesLeague_uidRoute = AppCricketLeaguesLeague_uidRouteImport.update({
            id: '/cricket/leagues/$league_uid',path: '/cricket/leagues/$league_uid',getParentRoute: () => AppRoute
          })
const AppCommunitiesCommunity_uidOverviewRoute = AppCommunitiesCommunity_uidOverviewRouteImport.update({
            id: '/communities/$community_uid/overview',path: '/communities/$community_uid/overview',getParentRoute: () => AppRoute
          })
const AppCommunitiesCommunity_uidEditRoute = AppCommunitiesCommunity_uidEditRouteImport.update({
            id: '/communities/$community_uid/edit',path: '/communities/$community_uid/edit',getParentRoute: () => AppRoute
          })
const AppCommunitiesCommunity_uidDashboardRoute = AppCommunitiesCommunity_uidDashboardRouteImport.update({
            id: '/communities/$community_uid/dashboard',path: '/communities/$community_uid/dashboard',getParentRoute: () => AppRoute
          })
const AppClubsClub_uidWagerLeaderboardRoute = AppClubsClub_uidWagerLeaderboardRouteImport.update({
            id: '/clubs/$club_uid/wager-leaderboard',path: '/clubs/$club_uid/wager-leaderboard',getParentRoute: () => AppRoute
          })
const AppClubsClub_uidReviewsRoute = AppClubsClub_uidReviewsRouteImport.update({
            id: '/clubs/$club_uid/reviews',path: '/clubs/$club_uid/reviews',getParentRoute: () => AppRoute
          })
const AppClubsClub_uidOverviewRoute = AppClubsClub_uidOverviewRouteImport.update({
            id: '/clubs/$club_uid/overview',path: '/clubs/$club_uid/overview',getParentRoute: () => AppRoute
          })
const AppClubsClub_uidManageRoute = AppClubsClub_uidManageRouteImport.update({
            id: '/clubs/$club_uid/manage',path: '/clubs/$club_uid/manage',getParentRoute: () => AppRoute
          })
const AppClubsClub_uidLeaderboardRoute = AppClubsClub_uidLeaderboardRouteImport.update({
            id: '/clubs/$club_uid/leaderboard',path: '/clubs/$club_uid/leaderboard',getParentRoute: () => AppRoute
          })
const AppClubsClub_uidFriendlyWagersRoute = AppClubsClub_uidFriendlyWagersRouteImport.update({
            id: '/clubs/$club_uid/friendly-wagers',path: '/clubs/$club_uid/friendly-wagers',getParentRoute: () => AppRoute
          })
const AppClubsClub_uidEditRoute = AppClubsClub_uidEditRouteImport.update({
            id: '/clubs/$club_uid/edit',path: '/clubs/$club_uid/edit',getParentRoute: () => AppRoute
          })
const AppClubsClub_uidDashboardRoute = AppClubsClub_uidDashboardRouteImport.update({
            id: '/clubs/$club_uid/dashboard',path: '/clubs/$club_uid/dashboard',getParentRoute: () => AppRoute
          })
const AppClubsClub_uidCourtsBookingRoute = AppClubsClub_uidCourtsBookingRouteImport.update({
            id: '/clubs/$club_uid/courts-booking',path: '/clubs/$club_uid/courts-booking',getParentRoute: () => AppRoute
          })
const AppClubsClub_uidCourtSetupRoute = AppClubsClub_uidCourtSetupRouteImport.update({
            id: '/clubs/$club_uid/court-setup',path: '/clubs/$club_uid/court-setup',getParentRoute: () => AppRoute
          })
const AppClubsClub_uidBookingsRoute = AppClubsClub_uidBookingsRouteImport.update({
            id: '/clubs/$club_uid/bookings',path: '/clubs/$club_uid/bookings',getParentRoute: () => AppRoute
          })
const AppClubsClub_uidBillingRoute = AppClubsClub_uidBillingRouteImport.update({
            id: '/clubs/$club_uid/billing',path: '/clubs/$club_uid/billing',getParentRoute: () => AppRoute
          })
const AppClashOfTeamsUidPageRoute = AppClashOfTeamsUidPageRouteImport.update({
            id: '/clash-of-teams/$uid/$page',path: '/clash-of-teams/$uid/$page',getParentRoute: () => AppRoute
          })
const AppBasketballTournamentsNewRoute = AppBasketballTournamentsNewRouteImport.update({
            id: '/basketball/tournaments/new',path: '/basketball/tournaments/new',getParentRoute: () => AppRoute
          })
const AppBasketballTournamentsTournament_uidRoute = AppBasketballTournamentsTournament_uidRouteImport.update({
            id: '/basketball/tournaments/$tournament_uid',path: '/basketball/tournaments/$tournament_uid',getParentRoute: () => AppRoute
          })
const AppBasketballLeaguesLeague_uidRoute = AppBasketballLeaguesLeague_uidRouteImport.update({
            id: '/basketball/leagues/$league_uid',path: '/basketball/leagues/$league_uid',getParentRoute: () => AppRoute
          })
const AppTournamentsTournament_uidPageRoute = AppTournamentsTournament_uidPageRouteImport.update({
            id: '/$page',path: '/$page',getParentRoute: () => AppTournamentsTournament_uidRoute
          })
const AppRydercupUidPageRoute = AppRydercupUidPageRouteImport.update({
            id: '/$page',path: '/$page',getParentRoute: () => AppRydercupUidRoute
          })
const AppMexicanosMexicano_uidPageRoute = AppMexicanosMexicano_uidPageRouteImport.update({
            id: '/$page',path: '/$page',getParentRoute: () => AppMexicanosMexicano_uidRoute
          })
const AppMasterUsersUser_uidRoute = AppMasterUsersUser_uidRouteImport.update({
            id: '/$user_uid',path: '/$user_uid',getParentRoute: () => AppMasterUsersRoute
          })
const AppMasterSubscriptionsPost_uidRoute = AppMasterSubscriptionsPost_uidRouteImport.update({
            id: '/$post_uid',path: '/$post_uid',getParentRoute: () => AppMasterSubscriptionsRoute
          })
const AppMasterPostsPost_uidRoute = AppMasterPostsPost_uidRouteImport.update({
            id: '/$post_uid',path: '/$post_uid',getParentRoute: () => AppMasterPostsRoute
          })
const AppMasterPlayersPlayer_uidRoute = AppMasterPlayersPlayer_uidRouteImport.update({
            id: '/$player_uid',path: '/$player_uid',getParentRoute: () => AppMasterPlayersRoute
          })
const AppLeaguesLeague_uidPageRoute = AppLeaguesLeague_uidPageRouteImport.update({
            id: '/$page',path: '/$page',getParentRoute: () => AppLeaguesLeague_uidRoute
          })
const AppKotcKotc_uidPageRoute = AppKotcKotc_uidPageRouteImport.update({
            id: '/$page',path: '/$page',getParentRoute: () => AppKotcKotc_uidRoute
          })
const AppAmericanosAmericano_uidPageRoute = AppAmericanosAmericano_uidPageRouteImport.update({
            id: '/$page',path: '/$page',getParentRoute: () => AppAmericanosAmericano_uidRoute
          })
const AppVolleyballTournamentsTournament_uidPageRoute = AppVolleyballTournamentsTournament_uidPageRouteImport.update({
            id: '/$page',path: '/$page',getParentRoute: () => AppVolleyballTournamentsTournament_uidRoute
          })
const AppVolleyballLeaguesLeague_uidPageRoute = AppVolleyballLeaguesLeague_uidPageRouteImport.update({
            id: '/$page',path: '/$page',getParentRoute: () => AppVolleyballLeaguesLeague_uidRoute
          })
const AppRoundnetTournamentsTournament_uidPageRoute = AppRoundnetTournamentsTournament_uidPageRouteImport.update({
            id: '/$page',path: '/$page',getParentRoute: () => AppRoundnetTournamentsTournament_uidRoute
          })
const AppRoundnetLeaguesLeague_uidPageRoute = AppRoundnetLeaguesLeague_uidPageRouteImport.update({
            id: '/$page',path: '/$page',getParentRoute: () => AppRoundnetLeaguesLeague_uidRoute
          })
const AppFootballTournamentsTournament_uidPageRoute = AppFootballTournamentsTournament_uidPageRouteImport.update({
            id: '/$page',path: '/$page',getParentRoute: () => AppFootballTournamentsTournament_uidRoute
          })
const AppFootballLeaguesLeague_uidPageRoute = AppFootballLeaguesLeague_uidPageRouteImport.update({
            id: '/$page',path: '/$page',getParentRoute: () => AppFootballLeaguesLeague_uidRoute
          })
const AppEsportsTournamentsTournament_uidPageRoute = AppEsportsTournamentsTournament_uidPageRouteImport.update({
            id: '/$page',path: '/$page',getParentRoute: () => AppEsportsTournamentsTournament_uidRoute
          })
const AppEsportsLeaguesLeague_uidPageRoute = AppEsportsLeaguesLeague_uidPageRouteImport.update({
            id: '/$page',path: '/$page',getParentRoute: () => AppEsportsLeaguesLeague_uidRoute
          })
const AppCricketTournamentsTournament_uidPageRoute = AppCricketTournamentsTournament_uidPageRouteImport.update({
            id: '/$page',path: '/$page',getParentRoute: () => AppCricketTournamentsTournament_uidRoute
          })
const AppCricketLeaguesLeague_uidPageRoute = AppCricketLeaguesLeague_uidPageRouteImport.update({
            id: '/$page',path: '/$page',getParentRoute: () => AppCricketLeaguesLeague_uidRoute
          })
const AppBasketballTournamentsTournament_uidPageRoute = AppBasketballTournamentsTournament_uidPageRouteImport.update({
            id: '/$page',path: '/$page',getParentRoute: () => AppBasketballTournamentsTournament_uidRoute
          })
const AppBasketballLeaguesLeague_uidPageRoute = AppBasketballLeaguesLeague_uidPageRouteImport.update({
            id: '/$page',path: '/$page',getParentRoute: () => AppBasketballLeaguesLeague_uidRoute
          })
const AppTournamentsTournament_uidPageSubpageRoute = AppTournamentsTournament_uidPageSubpageRouteImport.update({
            id: '/$subpage',path: '/$subpage',getParentRoute: () => AppTournamentsTournament_uidPageRoute
          })
const AppRydercupUidRoundRoundNumberRoute = AppRydercupUidRoundRoundNumberRouteImport.update({
            id: '/round/$roundNumber',path: '/round/$roundNumber',getParentRoute: () => AppRydercupUidRoute
          })
const AppLeaguesLeague_uidPlayerPlayer_uidRoute = AppLeaguesLeague_uidPlayerPlayer_uidRouteImport.update({
            id: '/player/$player_uid',path: '/player/$player_uid',getParentRoute: () => AppLeaguesLeague_uidRoute
          })
const AppLeaguesLeague_uidGameGame_uidRoute = AppLeaguesLeague_uidGameGame_uidRouteImport.update({
            id: '/game/$game_uid',path: '/game/$game_uid',getParentRoute: () => AppLeaguesLeague_uidRoute
          })
const AppLeaguesLeague_uidPageSubpageRoute = AppLeaguesLeague_uidPageSubpageRouteImport.update({
            id: '/$subpage',path: '/$subpage',getParentRoute: () => AppLeaguesLeague_uidPageRoute
          })
const AppVolleyballTournamentsTournament_uidPageSubpageRoute = AppVolleyballTournamentsTournament_uidPageSubpageRouteImport.update({
            id: '/$subpage',path: '/$subpage',getParentRoute: () => AppVolleyballTournamentsTournament_uidPageRoute
          })
const AppVolleyballLeaguesLeague_uidGameGame_uidRoute = AppVolleyballLeaguesLeague_uidGameGame_uidRouteImport.update({
            id: '/game/$game_uid',path: '/game/$game_uid',getParentRoute: () => AppVolleyballLeaguesLeague_uidRoute
          })
const AppVolleyballLeaguesLeague_uidPageSubpageRoute = AppVolleyballLeaguesLeague_uidPageSubpageRouteImport.update({
            id: '/$subpage',path: '/$subpage',getParentRoute: () => AppVolleyballLeaguesLeague_uidPageRoute
          })
const AppRoundnetTournamentsTournament_uidPageSubpageRoute = AppRoundnetTournamentsTournament_uidPageSubpageRouteImport.update({
            id: '/$subpage',path: '/$subpage',getParentRoute: () => AppRoundnetTournamentsTournament_uidPageRoute
          })
const AppRoundnetLeaguesLeague_uidGameGame_uidRoute = AppRoundnetLeaguesLeague_uidGameGame_uidRouteImport.update({
            id: '/game/$game_uid',path: '/game/$game_uid',getParentRoute: () => AppRoundnetLeaguesLeague_uidRoute
          })
const AppRoundnetLeaguesLeague_uidPageSubpageRoute = AppRoundnetLeaguesLeague_uidPageSubpageRouteImport.update({
            id: '/$subpage',path: '/$subpage',getParentRoute: () => AppRoundnetLeaguesLeague_uidPageRoute
          })
const AppFootballTournamentsTournament_uidPageSubpageRoute = AppFootballTournamentsTournament_uidPageSubpageRouteImport.update({
            id: '/$subpage',path: '/$subpage',getParentRoute: () => AppFootballTournamentsTournament_uidPageRoute
          })
const AppFootballLeaguesLeague_uidGameGame_uidRoute = AppFootballLeaguesLeague_uidGameGame_uidRouteImport.update({
            id: '/game/$game_uid',path: '/game/$game_uid',getParentRoute: () => AppFootballLeaguesLeague_uidRoute
          })
const AppFootballLeaguesLeague_uidPageSubpageRoute = AppFootballLeaguesLeague_uidPageSubpageRouteImport.update({
            id: '/$subpage',path: '/$subpage',getParentRoute: () => AppFootballLeaguesLeague_uidPageRoute
          })
const AppEsportsTournamentsTournament_uidPageSubpageRoute = AppEsportsTournamentsTournament_uidPageSubpageRouteImport.update({
            id: '/$subpage',path: '/$subpage',getParentRoute: () => AppEsportsTournamentsTournament_uidPageRoute
          })
const AppEsportsLeaguesLeague_uidGameGame_uidRoute = AppEsportsLeaguesLeague_uidGameGame_uidRouteImport.update({
            id: '/game/$game_uid',path: '/game/$game_uid',getParentRoute: () => AppEsportsLeaguesLeague_uidRoute
          })
const AppEsportsLeaguesLeague_uidPageSubpageRoute = AppEsportsLeaguesLeague_uidPageSubpageRouteImport.update({
            id: '/$subpage',path: '/$subpage',getParentRoute: () => AppEsportsLeaguesLeague_uidPageRoute
          })
const AppCricketTournamentsTournament_uidPageSubpageRoute = AppCricketTournamentsTournament_uidPageSubpageRouteImport.update({
            id: '/$subpage',path: '/$subpage',getParentRoute: () => AppCricketTournamentsTournament_uidPageRoute
          })
const AppCricketLeaguesLeague_uidGameGame_uidRoute = AppCricketLeaguesLeague_uidGameGame_uidRouteImport.update({
            id: '/game/$game_uid',path: '/game/$game_uid',getParentRoute: () => AppCricketLeaguesLeague_uidRoute
          })
const AppCricketLeaguesLeague_uidPageSubpageRoute = AppCricketLeaguesLeague_uidPageSubpageRouteImport.update({
            id: '/$subpage',path: '/$subpage',getParentRoute: () => AppCricketLeaguesLeague_uidPageRoute
          })
const AppBasketballTournamentsTournament_uidPageSubpageRoute = AppBasketballTournamentsTournament_uidPageSubpageRouteImport.update({
            id: '/$subpage',path: '/$subpage',getParentRoute: () => AppBasketballTournamentsTournament_uidPageRoute
          })
const AppBasketballLeaguesLeague_uidGameGame_uidRoute = AppBasketballLeaguesLeague_uidGameGame_uidRouteImport.update({
            id: '/game/$game_uid',path: '/game/$game_uid',getParentRoute: () => AppBasketballLeaguesLeague_uidRoute
          })
const AppBasketballLeaguesLeague_uidPageSubpageRoute = AppBasketballLeaguesLeague_uidPageSubpageRouteImport.update({
            id: '/$subpage',path: '/$subpage',getParentRoute: () => AppBasketballLeaguesLeague_uidPageRoute
          })
const PublicTournamentsTournament_uidApplicationsApplication_uidPayEntryFeeRoute = PublicTournamentsTournament_uidApplicationsApplication_uidPayEntryFeeRouteImport.update({
            id: '/public/tournaments/$tournament_uid/applications/$application_uid/pay-entry-fee/',path: '/public/tournaments/$tournament_uid/applications/$application_uid/pay-entry-fee/',getParentRoute: () => rootRouteImport
          })
const PublicLeaguesLeague_uidApplicationsApplication_uidPayEntryFeeRoute = PublicLeaguesLeague_uidApplicationsApplication_uidPayEntryFeeRouteImport.update({
            id: '/public/leagues/$league_uid/applications/$application_uid/pay-entry-fee/',path: '/public/leagues/$league_uid/applications/$application_uid/pay-entry-fee/',getParentRoute: () => rootRouteImport
          })





const AppAmericanosAmericano_uidRouteChildren = {
  AppAmericanosAmericano_uidPageRoute: AppAmericanosAmericano_uidPageRoute
}

const AppAmericanosAmericano_uidRouteWithChildren = AppAmericanosAmericano_uidRoute._addFileChildren(AppAmericanosAmericano_uidRouteChildren)




const AppKotcKotc_uidRouteChildren = {
  AppKotcKotc_uidPageRoute: AppKotcKotc_uidPageRoute
}

const AppKotcKotc_uidRouteWithChildren = AppKotcKotc_uidRoute._addFileChildren(AppKotcKotc_uidRouteChildren)




const AppLeaguesLeague_uidPageRouteChildren = {
  AppLeaguesLeague_uidPageSubpageRoute: AppLeaguesLeague_uidPageSubpageRoute
}

const AppLeaguesLeague_uidPageRouteWithChildren = AppLeaguesLeague_uidPageRoute._addFileChildren(AppLeaguesLeague_uidPageRouteChildren)



const AppLeaguesLeague_uidRouteChildren = {
  AppLeaguesLeague_uidPageRoute: AppLeaguesLeague_uidPageRouteWithChildren,AppLeaguesLeague_uidGameGame_uidRoute: AppLeaguesLeague_uidGameGame_uidRoute,AppLeaguesLeague_uidPlayerPlayer_uidRoute: AppLeaguesLeague_uidPlayerPlayer_uidRoute
}

const AppLeaguesLeague_uidRouteWithChildren = AppLeaguesLeague_uidRoute._addFileChildren(AppLeaguesLeague_uidRouteChildren)




const AppMasterPlayersRouteChildren = {
  AppMasterPlayersPlayer_uidRoute: AppMasterPlayersPlayer_uidRoute
}

const AppMasterPlayersRouteWithChildren = AppMasterPlayersRoute._addFileChildren(AppMasterPlayersRouteChildren)




const AppMasterPostsRouteChildren = {
  AppMasterPostsPost_uidRoute: AppMasterPostsPost_uidRoute
}

const AppMasterPostsRouteWithChildren = AppMasterPostsRoute._addFileChildren(AppMasterPostsRouteChildren)




const AppMasterSubscriptionsRouteChildren = {
  AppMasterSubscriptionsPost_uidRoute: AppMasterSubscriptionsPost_uidRoute
}

const AppMasterSubscriptionsRouteWithChildren = AppMasterSubscriptionsRoute._addFileChildren(AppMasterSubscriptionsRouteChildren)




const AppMasterUsersRouteChildren = {
  AppMasterUsersUser_uidRoute: AppMasterUsersUser_uidRoute
}

const AppMasterUsersRouteWithChildren = AppMasterUsersRoute._addFileChildren(AppMasterUsersRouteChildren)




const AppMexicanosMexicano_uidRouteChildren = {
  AppMexicanosMexicano_uidPageRoute: AppMexicanosMexicano_uidPageRoute
}

const AppMexicanosMexicano_uidRouteWithChildren = AppMexicanosMexicano_uidRoute._addFileChildren(AppMexicanosMexicano_uidRouteChildren)




const AppRydercupUidRouteChildren = {
  AppRydercupUidPageRoute: AppRydercupUidPageRoute,AppRydercupUidRoundRoundNumberRoute: AppRydercupUidRoundRoundNumberRoute
}

const AppRydercupUidRouteWithChildren = AppRydercupUidRoute._addFileChildren(AppRydercupUidRouteChildren)




const AppTournamentsTournament_uidPageRouteChildren = {
  AppTournamentsTournament_uidPageSubpageRoute: AppTournamentsTournament_uidPageSubpageRoute
}

const AppTournamentsTournament_uidPageRouteWithChildren = AppTournamentsTournament_uidPageRoute._addFileChildren(AppTournamentsTournament_uidPageRouteChildren)



const AppTournamentsTournament_uidRouteChildren = {
  AppTournamentsTournament_uidPageRoute: AppTournamentsTournament_uidPageRouteWithChildren
}

const AppTournamentsTournament_uidRouteWithChildren = AppTournamentsTournament_uidRoute._addFileChildren(AppTournamentsTournament_uidRouteChildren)




const AppBasketballLeaguesLeague_uidPageRouteChildren = {
  AppBasketballLeaguesLeague_uidPageSubpageRoute: AppBasketballLeaguesLeague_uidPageSubpageRoute
}

const AppBasketballLeaguesLeague_uidPageRouteWithChildren = AppBasketballLeaguesLeague_uidPageRoute._addFileChildren(AppBasketballLeaguesLeague_uidPageRouteChildren)



const AppBasketballLeaguesLeague_uidRouteChildren = {
  AppBasketballLeaguesLeague_uidPageRoute: AppBasketballLeaguesLeague_uidPageRouteWithChildren,AppBasketballLeaguesLeague_uidGameGame_uidRoute: AppBasketballLeaguesLeague_uidGameGame_uidRoute
}

const AppBasketballLeaguesLeague_uidRouteWithChildren = AppBasketballLeaguesLeague_uidRoute._addFileChildren(AppBasketballLeaguesLeague_uidRouteChildren)




const AppBasketballTournamentsTournament_uidPageRouteChildren = {
  AppBasketballTournamentsTournament_uidPageSubpageRoute: AppBasketballTournamentsTournament_uidPageSubpageRoute
}

const AppBasketballTournamentsTournament_uidPageRouteWithChildren = AppBasketballTournamentsTournament_uidPageRoute._addFileChildren(AppBasketballTournamentsTournament_uidPageRouteChildren)



const AppBasketballTournamentsTournament_uidRouteChildren = {
  AppBasketballTournamentsTournament_uidPageRoute: AppBasketballTournamentsTournament_uidPageRouteWithChildren
}

const AppBasketballTournamentsTournament_uidRouteWithChildren = AppBasketballTournamentsTournament_uidRoute._addFileChildren(AppBasketballTournamentsTournament_uidRouteChildren)




const AppCricketLeaguesLeague_uidPageRouteChildren = {
  AppCricketLeaguesLeague_uidPageSubpageRoute: AppCricketLeaguesLeague_uidPageSubpageRoute
}

const AppCricketLeaguesLeague_uidPageRouteWithChildren = AppCricketLeaguesLeague_uidPageRoute._addFileChildren(AppCricketLeaguesLeague_uidPageRouteChildren)



const AppCricketLeaguesLeague_uidRouteChildren = {
  AppCricketLeaguesLeague_uidPageRoute: AppCricketLeaguesLeague_uidPageRouteWithChildren,AppCricketLeaguesLeague_uidGameGame_uidRoute: AppCricketLeaguesLeague_uidGameGame_uidRoute
}

const AppCricketLeaguesLeague_uidRouteWithChildren = AppCricketLeaguesLeague_uidRoute._addFileChildren(AppCricketLeaguesLeague_uidRouteChildren)




const AppCricketTournamentsTournament_uidPageRouteChildren = {
  AppCricketTournamentsTournament_uidPageSubpageRoute: AppCricketTournamentsTournament_uidPageSubpageRoute
}

const AppCricketTournamentsTournament_uidPageRouteWithChildren = AppCricketTournamentsTournament_uidPageRoute._addFileChildren(AppCricketTournamentsTournament_uidPageRouteChildren)



const AppCricketTournamentsTournament_uidRouteChildren = {
  AppCricketTournamentsTournament_uidPageRoute: AppCricketTournamentsTournament_uidPageRouteWithChildren
}

const AppCricketTournamentsTournament_uidRouteWithChildren = AppCricketTournamentsTournament_uidRoute._addFileChildren(AppCricketTournamentsTournament_uidRouteChildren)




const AppEsportsLeaguesLeague_uidPageRouteChildren = {
  AppEsportsLeaguesLeague_uidPageSubpageRoute: AppEsportsLeaguesLeague_uidPageSubpageRoute
}

const AppEsportsLeaguesLeague_uidPageRouteWithChildren = AppEsportsLeaguesLeague_uidPageRoute._addFileChildren(AppEsportsLeaguesLeague_uidPageRouteChildren)



const AppEsportsLeaguesLeague_uidRouteChildren = {
  AppEsportsLeaguesLeague_uidPageRoute: AppEsportsLeaguesLeague_uidPageRouteWithChildren,AppEsportsLeaguesLeague_uidGameGame_uidRoute: AppEsportsLeaguesLeague_uidGameGame_uidRoute
}

const AppEsportsLeaguesLeague_uidRouteWithChildren = AppEsportsLeaguesLeague_uidRoute._addFileChildren(AppEsportsLeaguesLeague_uidRouteChildren)




const AppEsportsTournamentsTournament_uidPageRouteChildren = {
  AppEsportsTournamentsTournament_uidPageSubpageRoute: AppEsportsTournamentsTournament_uidPageSubpageRoute
}

const AppEsportsTournamentsTournament_uidPageRouteWithChildren = AppEsportsTournamentsTournament_uidPageRoute._addFileChildren(AppEsportsTournamentsTournament_uidPageRouteChildren)



const AppEsportsTournamentsTournament_uidRouteChildren = {
  AppEsportsTournamentsTournament_uidPageRoute: AppEsportsTournamentsTournament_uidPageRouteWithChildren
}

const AppEsportsTournamentsTournament_uidRouteWithChildren = AppEsportsTournamentsTournament_uidRoute._addFileChildren(AppEsportsTournamentsTournament_uidRouteChildren)




const AppFootballLeaguesLeague_uidPageRouteChildren = {
  AppFootballLeaguesLeague_uidPageSubpageRoute: AppFootballLeaguesLeague_uidPageSubpageRoute
}

const AppFootballLeaguesLeague_uidPageRouteWithChildren = AppFootballLeaguesLeague_uidPageRoute._addFileChildren(AppFootballLeaguesLeague_uidPageRouteChildren)



const AppFootballLeaguesLeague_uidRouteChildren = {
  AppFootballLeaguesLeague_uidPageRoute: AppFootballLeaguesLeague_uidPageRouteWithChildren,AppFootballLeaguesLeague_uidGameGame_uidRoute: AppFootballLeaguesLeague_uidGameGame_uidRoute
}

const AppFootballLeaguesLeague_uidRouteWithChildren = AppFootballLeaguesLeague_uidRoute._addFileChildren(AppFootballLeaguesLeague_uidRouteChildren)




const AppFootballTournamentsTournament_uidPageRouteChildren = {
  AppFootballTournamentsTournament_uidPageSubpageRoute: AppFootballTournamentsTournament_uidPageSubpageRoute
}

const AppFootballTournamentsTournament_uidPageRouteWithChildren = AppFootballTournamentsTournament_uidPageRoute._addFileChildren(AppFootballTournamentsTournament_uidPageRouteChildren)



const AppFootballTournamentsTournament_uidRouteChildren = {
  AppFootballTournamentsTournament_uidPageRoute: AppFootballTournamentsTournament_uidPageRouteWithChildren
}

const AppFootballTournamentsTournament_uidRouteWithChildren = AppFootballTournamentsTournament_uidRoute._addFileChildren(AppFootballTournamentsTournament_uidRouteChildren)




const AppRoundnetLeaguesLeague_uidPageRouteChildren = {
  AppRoundnetLeaguesLeague_uidPageSubpageRoute: AppRoundnetLeaguesLeague_uidPageSubpageRoute
}

const AppRoundnetLeaguesLeague_uidPageRouteWithChildren = AppRoundnetLeaguesLeague_uidPageRoute._addFileChildren(AppRoundnetLeaguesLeague_uidPageRouteChildren)



const AppRoundnetLeaguesLeague_uidRouteChildren = {
  AppRoundnetLeaguesLeague_uidPageRoute: AppRoundnetLeaguesLeague_uidPageRouteWithChildren,AppRoundnetLeaguesLeague_uidGameGame_uidRoute: AppRoundnetLeaguesLeague_uidGameGame_uidRoute
}

const AppRoundnetLeaguesLeague_uidRouteWithChildren = AppRoundnetLeaguesLeague_uidRoute._addFileChildren(AppRoundnetLeaguesLeague_uidRouteChildren)




const AppRoundnetTournamentsTournament_uidPageRouteChildren = {
  AppRoundnetTournamentsTournament_uidPageSubpageRoute: AppRoundnetTournamentsTournament_uidPageSubpageRoute
}

const AppRoundnetTournamentsTournament_uidPageRouteWithChildren = AppRoundnetTournamentsTournament_uidPageRoute._addFileChildren(AppRoundnetTournamentsTournament_uidPageRouteChildren)



const AppRoundnetTournamentsTournament_uidRouteChildren = {
  AppRoundnetTournamentsTournament_uidPageRoute: AppRoundnetTournamentsTournament_uidPageRouteWithChildren
}

const AppRoundnetTournamentsTournament_uidRouteWithChildren = AppRoundnetTournamentsTournament_uidRoute._addFileChildren(AppRoundnetTournamentsTournament_uidRouteChildren)




const AppVolleyballLeaguesLeague_uidPageRouteChildren = {
  AppVolleyballLeaguesLeague_uidPageSubpageRoute: AppVolleyballLeaguesLeague_uidPageSubpageRoute
}

const AppVolleyballLeaguesLeague_uidPageRouteWithChildren = AppVolleyballLeaguesLeague_uidPageRoute._addFileChildren(AppVolleyballLeaguesLeague_uidPageRouteChildren)



const AppVolleyballLeaguesLeague_uidRouteChildren = {
  AppVolleyballLeaguesLeague_uidPageRoute: AppVolleyballLeaguesLeague_uidPageRouteWithChildren,AppVolleyballLeaguesLeague_uidGameGame_uidRoute: AppVolleyballLeaguesLeague_uidGameGame_uidRoute
}

const AppVolleyballLeaguesLeague_uidRouteWithChildren = AppVolleyballLeaguesLeague_uidRoute._addFileChildren(AppVolleyballLeaguesLeague_uidRouteChildren)




const AppVolleyballTournamentsTournament_uidPageRouteChildren = {
  AppVolleyballTournamentsTournament_uidPageSubpageRoute: AppVolleyballTournamentsTournament_uidPageSubpageRoute
}

const AppVolleyballTournamentsTournament_uidPageRouteWithChildren = AppVolleyballTournamentsTournament_uidPageRoute._addFileChildren(AppVolleyballTournamentsTournament_uidPageRouteChildren)



const AppVolleyballTournamentsTournament_uidRouteChildren = {
  AppVolleyballTournamentsTournament_uidPageRoute: AppVolleyballTournamentsTournament_uidPageRouteWithChildren
}

const AppVolleyballTournamentsTournament_uidRouteWithChildren = AppVolleyballTournamentsTournament_uidRoute._addFileChildren(AppVolleyballTournamentsTournament_uidRouteChildren)



const AppRouteChildren = {
  AppBillingRoute: AppBillingRoute,AppComingSoonRoute: AppComingSoonRoute,AppGlobalRankingLeagueRoute: AppGlobalRankingLeagueRoute,AppManagedEventsRoute: AppManagedEventsRoute,AppSocialGamesRoute: AppSocialGamesRoute,AppTierJourneyRoute: AppTierJourneyRoute,AppTournamentsChoiceRoute: AppTournamentsChoiceRoute,AppAiAi_uidRoute: AppAiAi_uidRoute,AppAmericanosAmericano_uidRoute: AppAmericanosAmericano_uidRouteWithChildren,AppAmericanosActivateRoute: AppAmericanosActivateRoute,AppAmericanosCreateRoute: AppAmericanosCreateRoute,AppBookCourtCheckoutRoute: AppBookCourtCheckoutRoute,AppCourtsBookingSplatRoute: AppCourtsBookingSplatRoute,AppFootballRecordRoute: AppFootballRecordRoute,AppFootballSocialRoute: AppFootballSocialRoute,AppFriendlyWagersGame_uidRoute: AppFriendlyWagersGame_uidRoute,AppGoPaymentsRoute: AppGoPaymentsRoute,AppKotcKotc_uidRoute: AppKotcKotc_uidRouteWithChildren,AppKotcCreateRoute: AppKotcCreateRoute,AppLeaguesLeague_uidRoute: AppLeaguesLeague_uidRouteWithChildren,AppMarketplaceCategoryRoute: AppMarketplaceCategoryRoute,AppMasterActivationRoute: AppMasterActivationRoute,AppMasterAiPromptsRoute: AppMasterAiPromptsRoute,AppMasterAnalyticsRoute: AppMasterAnalyticsRoute,AppMasterAuditsRoute: AppMasterAuditsRoute,AppMasterCampaignsRoute: AppMasterCampaignsRoute,AppMasterClientErrorsRoute: AppMasterClientErrorsRoute,AppMasterClubListingsRoute: AppMasterClubListingsRoute,AppMasterCoinsRedemptionsRoute: AppMasterCoinsRedemptionsRoute,AppMasterEmbedsRoute: AppMasterEmbedsRoute,AppMasterEventPassFeedbackRoute: AppMasterEventPassFeedbackRoute,AppMasterEventsRoute: AppMasterEventsRoute,AppMasterPlayersRoute: AppMasterPlayersRouteWithChildren,AppMasterPostsRoute: AppMasterPostsRouteWithChildren,AppMasterPricingLabRoute: AppMasterPricingLabRoute,AppMasterProductsRoute: AppMasterProductsRoute,AppMasterPushNotificationsRoute: AppMasterPushNotificationsRoute,AppMasterQuizResponsesRoute: AppMasterQuizResponsesRoute,AppMasterReferralsRoute: AppMasterReferralsRoute,AppMasterScorecardsRoute: AppMasterScorecardsRoute,AppMasterScorepalQuizRoute: AppMasterScorepalQuizRoute,AppMasterSubscriptionsRoute: AppMasterSubscriptionsRouteWithChildren,AppMasterSupportRoute: AppMasterSupportRoute,AppMasterTournamentPlacementsRoute: AppMasterTournamentPlacementsRoute,AppMasterTransactionsRoute: AppMasterTransactionsRoute,AppMasterUsersRoute: AppMasterUsersRouteWithChildren,AppMasterVenuesRoute: AppMasterVenuesRoute,AppMexicanosMexicano_uidRoute: AppMexicanosMexicano_uidRouteWithChildren,AppMexicanosCreateRoute: AppMexicanosCreateRoute,AppPlayersPlayer_uidRoute: AppPlayersPlayer_uidRoute,AppPlayersNewRoute: AppPlayersNewRoute,AppProfileMessagesRoute: AppProfileMessagesRoute,AppProfileRecentMatchesRoute: AppProfileRecentMatchesRoute,AppProfileUpcomingGamesRoute: AppProfileUpcomingGamesRoute,AppProfilesMeRoute: AppProfilesMeRoute,AppRunningDashboardRoute: AppRunningDashboardRoute,AppRunningUploadRoute: AppRunningUploadRoute,AppRydercupUidRoute: AppRydercupUidRouteWithChildren,AppRydercupCreateRoute: AppRydercupCreateRoute,AppTournamentsRankingTablesRanking_group_uidRoute: AppTournamentsRankingTablesRanking_group_uidRoute,AppTournamentsRankingRanking_group_uidRoute: AppTournamentsRankingRanking_group_uidRoute,AppTournamentsTournament_uidRoute: AppTournamentsTournament_uidRouteWithChildren,AppTournamentsNewRoute: AppTournamentsNewRoute,AppAbilitiesIndexRoute: AppAbilitiesIndexRoute,AppAiIndexRoute: AppAiIndexRoute,AppAmericanosIndexRoute: AppAmericanosIndexRoute,AppBasketballIndexRoute: AppBasketballIndexRoute,AppBookCourtIndexRoute: AppBookCourtIndexRoute,AppCirclesIndexRoute: AppCirclesIndexRoute,AppClashOfTeamsIndexRoute: AppClashOfTeamsIndexRoute,AppClubsIndexRoute: AppClubsIndexRoute,AppCommunitiesIndexRoute: AppCommunitiesIndexRoute,AppCricketIndexRoute: AppCricketIndexRoute,AppEarnIndexRoute: AppEarnIndexRoute,AppEsportsIndexRoute: AppEsportsIndexRoute,AppFootballIndexRoute: AppFootballIndexRoute,AppFriendlyWagersIndexRoute: AppFriendlyWagersIndexRoute,AppKotcIndexRoute: AppKotcIndexRoute,AppLeaguesIndexRoute: AppLeaguesIndexRoute,AppMarketplaceIndexRoute: AppMarketplaceIndexRoute,AppMessagesIndexRoute: AppMessagesIndexRoute,AppMexicanosIndexRoute: AppMexicanosIndexRoute,AppPlayersIndexRoute: AppPlayersIndexRoute,AppRoundnetIndexRoute: AppRoundnetIndexRoute,AppRunningIndexRoute: AppRunningIndexRoute,AppRydercupIndexRoute: AppRydercupIndexRoute,AppSessionsIndexRoute: AppSessionsIndexRoute,AppTournamentsRankingTablesIndexRoute: AppTournamentsRankingTablesIndexRoute,AppTournamentsRankingIndexRoute: AppTournamentsRankingIndexRoute,AppTournamentsIndexRoute: AppTournamentsIndexRoute,AppVolleyballIndexRoute: AppVolleyballIndexRoute,AppBasketballLeaguesLeague_uidRoute: AppBasketballLeaguesLeague_uidRouteWithChildren,AppBasketballTournamentsTournament_uidRoute: AppBasketballTournamentsTournament_uidRouteWithChildren,AppBasketballTournamentsNewRoute: AppBasketballTournamentsNewRoute,AppClashOfTeamsUidPageRoute: AppClashOfTeamsUidPageRoute,AppClubsClub_uidBillingRoute: AppClubsClub_uidBillingRoute,AppClubsClub_uidBookingsRoute: AppClubsClub_uidBookingsRoute,AppClubsClub_uidCourtSetupRoute: AppClubsClub_uidCourtSetupRoute,AppClubsClub_uidCourtsBookingRoute: AppClubsClub_uidCourtsBookingRoute,AppClubsClub_uidDashboardRoute: AppClubsClub_uidDashboardRoute,AppClubsClub_uidEditRoute: AppClubsClub_uidEditRoute,AppClubsClub_uidFriendlyWagersRoute: AppClubsClub_uidFriendlyWagersRoute,AppClubsClub_uidLeaderboardRoute: AppClubsClub_uidLeaderboardRoute,AppClubsClub_uidManageRoute: AppClubsClub_uidManageRoute,AppClubsClub_uidOverviewRoute: AppClubsClub_uidOverviewRoute,AppClubsClub_uidReviewsRoute: AppClubsClub_uidReviewsRoute,AppClubsClub_uidWagerLeaderboardRoute: AppClubsClub_uidWagerLeaderboardRoute,AppCommunitiesCommunity_uidDashboardRoute: AppCommunitiesCommunity_uidDashboardRoute,AppCommunitiesCommunity_uidEditRoute: AppCommunitiesCommunity_uidEditRoute,AppCommunitiesCommunity_uidOverviewRoute: AppCommunitiesCommunity_uidOverviewRoute,AppCricketLeaguesLeague_uidRoute: AppCricketLeaguesLeague_uidRouteWithChildren,AppCricketTournamentsTournament_uidRoute: AppCricketTournamentsTournament_uidRouteWithChildren,AppCricketTournamentsNewRoute: AppCricketTournamentsNewRoute,AppEsportsLeaguesLeague_uidRoute: AppEsportsLeaguesLeague_uidRouteWithChildren,AppEsportsTournamentsTournament_uidRoute: AppEsportsTournamentsTournament_uidRouteWithChildren,AppEsportsTournamentsNewRoute: AppEsportsTournamentsNewRoute,AppFootballLeaguesLeague_uidRoute: AppFootballLeaguesLeague_uidRouteWithChildren,AppFootballTournamentsTournament_uidRoute: AppFootballTournamentsTournament_uidRouteWithChildren,AppFootballTournamentsNewRoute: AppFootballTournamentsNewRoute,AppFriendlyWagersSummaryGame_uidRoute: AppFriendlyWagersSummaryGame_uidRoute,AppMarketplaceCheckoutGame_uidRoute: AppMarketplaceCheckoutGame_uidRoute,AppMarketplaceEditGame_uidRoute: AppMarketplaceEditGame_uidRoute,AppMarketplaceGamesGame_uidRoute: AppMarketplaceGamesGame_uidRoute,AppOrganizerCoachesCoach_uidRoute: AppOrganizerCoachesCoach_uidRoute,AppProfileGamesGame_uidRoute: AppProfileGamesGame_uidRoute,AppProfilesPlayer_uidDashboardRoute: AppProfilesPlayer_uidDashboardRoute,AppProfilesPlayer_uidEditRoute: AppProfilesPlayer_uidEditRoute,AppProfilesPlayer_uidReferralsRoute: AppProfilesPlayer_uidReferralsRoute,AppProfilesPlayer_uidStatsRoute: AppProfilesPlayer_uidStatsRoute,AppProfilesPlayer_uidWalletRoute: AppProfilesPlayer_uidWalletRoute,AppRoundnetLeaguesLeague_uidRoute: AppRoundnetLeaguesLeague_uidRouteWithChildren,AppRoundnetTournamentsTournament_uidRoute: AppRoundnetTournamentsTournament_uidRouteWithChildren,AppRoundnetTournamentsNewRoute: AppRoundnetTournamentsNewRoute,AppRunningLeaderboardsResultsRanking_group_uidRoute: AppRunningLeaderboardsResultsRanking_group_uidRoute,AppRunningLeaderboardsRanking_group_uidRoute: AppRunningLeaderboardsRanking_group_uidRoute,AppRunningRacesRace_uidRoute: AppRunningRacesRace_uidRoute,AppRunningResultsImport_uidRoute: AppRunningResultsImport_uidRoute,AppVolleyballLeaguesLeague_uidRoute: AppVolleyballLeaguesLeague_uidRouteWithChildren,AppVolleyballTournamentsTournament_uidRoute: AppVolleyballTournamentsTournament_uidRouteWithChildren,AppVolleyballTournamentsNewRoute: AppVolleyballTournamentsNewRoute,AppAbilitiesAssessment_uidIndexRoute: AppAbilitiesAssessment_uidIndexRoute,AppBasketballDashboardIndexRoute: AppBasketballDashboardIndexRoute,AppBasketballLeaguesIndexRoute: AppBasketballLeaguesIndexRoute,AppBasketballPlayersIndexRoute: AppBasketballPlayersIndexRoute,AppBasketballTeamsIndexRoute: AppBasketballTeamsIndexRoute,AppBasketballTournamentsIndexRoute: AppBasketballTournamentsIndexRoute,AppClubsClub_uidIndexRoute: AppClubsClub_uidIndexRoute,AppCommunitiesCommunity_uidIndexRoute: AppCommunitiesCommunity_uidIndexRoute,AppCricketDashboardIndexRoute: AppCricketDashboardIndexRoute,AppCricketLeaguesIndexRoute: AppCricketLeaguesIndexRoute,AppCricketPlayersIndexRoute: AppCricketPlayersIndexRoute,AppCricketTeamsIndexRoute: AppCricketTeamsIndexRoute,AppCricketTournamentsIndexRoute: AppCricketTournamentsIndexRoute,AppEsportsDashboardIndexRoute: AppEsportsDashboardIndexRoute,AppEsportsLeaguesIndexRoute: AppEsportsLeaguesIndexRoute,AppEsportsPlayersIndexRoute: AppEsportsPlayersIndexRoute,AppEsportsTeamsIndexRoute: AppEsportsTeamsIndexRoute,AppEsportsTournamentsIndexRoute: AppEsportsTournamentsIndexRoute,AppFootballDashboardIndexRoute: AppFootballDashboardIndexRoute,AppFootballLeaguesIndexRoute: AppFootballLeaguesIndexRoute,AppFootballPlayersIndexRoute: AppFootballPlayersIndexRoute,AppFootballTeamsIndexRoute: AppFootballTeamsIndexRoute,AppFootballTournamentsIndexRoute: AppFootballTournamentsIndexRoute,AppOrganizerAssessmentsIndexRoute: AppOrganizerAssessmentsIndexRoute,AppOrganizerCoachesIndexRoute: AppOrganizerCoachesIndexRoute,AppProfilesPlayer_uidIndexRoute: AppProfilesPlayer_uidIndexRoute,AppRoundnetDashboardIndexRoute: AppRoundnetDashboardIndexRoute,AppRoundnetLeaguesIndexRoute: AppRoundnetLeaguesIndexRoute,AppRoundnetPlayersIndexRoute: AppRoundnetPlayersIndexRoute,AppRoundnetTeamsIndexRoute: AppRoundnetTeamsIndexRoute,AppRoundnetTournamentsIndexRoute: AppRoundnetTournamentsIndexRoute,AppRunningRacesIndexRoute: AppRunningRacesIndexRoute,AppVolleyballDashboardIndexRoute: AppVolleyballDashboardIndexRoute,AppVolleyballLeaguesIndexRoute: AppVolleyballLeaguesIndexRoute,AppVolleyballPlayersIndexRoute: AppVolleyballPlayersIndexRoute,AppVolleyballTeamsIndexRoute: AppVolleyballTeamsIndexRoute,AppVolleyballTournamentsIndexRoute: AppVolleyballTournamentsIndexRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)




const QuizRouteChildren = {
  QuizActivateRoute: QuizActivateRoute
}

const QuizRouteWithChildren = QuizRoute._addFileChildren(QuizRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,Club_slugRoute: Club_slugRoute,AppRoute: AppRouteWithChildren,AboutRoute: AboutRoute,AmericanoGeneratorRoute: AmericanoGeneratorRoute,AmericanoMixerRoute: AmericanoMixerRoute,BadmintonTournamentSoftwareRoute: BadmintonTournamentSoftwareRoute,BasketballLeagueSoftwareRoute: BasketballLeagueSoftwareRoute,BasketballTournamentSoftwareRoute: BasketballTournamentSoftwareRoute,BuildRoute: BuildRoute,ClaimRoute: ClaimRoute,ClubDirectoryRoute: ClubDirectoryRoute,ConfirmEmailRoute: ConfirmEmailRoute,ConnectWhatsappRoute: ConnectWhatsappRoute,ContactRoute: ContactRoute,CookiePolicyRoute: CookiePolicyRoute,CopyCodeRoute: CopyCodeRoute,CreateBracketsRoute: CreateBracketsRoute,DisclaimerRoute: DisclaimerRoute,DocumentationRoute: DocumentationRoute,DoubleEliminationBracketGeneratorRoute: DoubleEliminationBracketGeneratorRoute,EsportsLeagueSoftwareRoute: EsportsLeagueSoftwareRoute,EsportsTournamentSoftwareRoute: EsportsTournamentSoftwareRoute,EventQuizRoute: EventQuizRoute,EventQuizV2Route: EventQuizV2Route,FaqRoute: FaqRoute,FindTournamentsRoute: FindTournamentsRoute,FinishProfileRoute: FinishProfileRoute,FootballLeagueSoftwareRoute: FootballLeagueSoftwareRoute,FootballTournamentSoftwareRoute: FootballTournamentSoftwareRoute,ForClubsRoute: ForClubsRoute,ForCommunitiesRoute: ForCommunitiesRoute,ForPlayersRoute: ForPlayersRoute,GroupAndKnockoutGeneratorRoute: GroupAndKnockoutGeneratorRoute,KingOfTheCourtGeneratorRoute: KingOfTheCourtGeneratorRoute,LadderLeagueGeneratorRoute: LadderLeagueGeneratorRoute,LeagueFormatsRoute: LeagueFormatsRoute,ListClubRoute: ListClubRoute,ListTournamentRoute: ListTournamentRoute,LiveScoringRoute: LiveScoringRoute,MexicanoTournamentGeneratorRoute: MexicanoTournamentGeneratorRoute,OldLandingRoute: OldLandingRoute,PadelLeagueSoftwareRoute: PadelLeagueSoftwareRoute,PadelTournamentSoftwareRoute: PadelTournamentSoftwareRoute,PickleballLeagueSoftwareRoute: PickleballLeagueSoftwareRoute,PickleballTournamentSoftwareRoute: PickleballTournamentSoftwareRoute,PricingRoute: PricingRoute,PricingV2Route: PricingV2Route,PrivacyRoute: PrivacyRoute,PrivacyLegacyRoute: PrivacyLegacyRoute,QuizRoute: QuizRouteWithChildren,QuizCommunityRoute: QuizCommunityRoute,QuizLegacyRoute: QuizLegacyRoute,RoundRobinTournamentGeneratorRoute: RoundRobinTournamentGeneratorRoute,RoundnetLeagueSoftwareRoute: RoundnetLeagueSoftwareRoute,RoundnetTournamentSoftwareRoute: RoundnetTournamentSoftwareRoute,SalesRoute: SalesRoute,SalesfunnelRoute: SalesfunnelRoute,ScorepalQuizRoute: ScorepalQuizRoute,SingleEliminationBracketGeneratorRoute: SingleEliminationBracketGeneratorRoute,SportsAnalyticsSoftwareForClubsRoute: SportsAnalyticsSoftwareForClubsRoute,SportsLeagueManagementSoftwareRoute: SportsLeagueManagementSoftwareRoute,SportsTournamentManagementSoftwareRoute: SportsTournamentManagementSoftwareRoute,SquashLeagueSoftwareRoute: SquashLeagueSoftwareRoute,SquashTournamentSoftwareRoute: SquashTournamentSoftwareRoute,SwissSystemTournamentGeneratorRoute: SwissSystemTournamentGeneratorRoute,TennisLeagueSoftwareRoute: TennisLeagueSoftwareRoute,TennisTournamentSoftwareRoute: TennisTournamentSoftwareRoute,TermsRoute: TermsRoute,TournamentFormatsRoute: TournamentFormatsRoute,TournamentManagementSoftwareRoute: TournamentManagementSoftwareRoute,VolleyballLeagueSoftwareRoute: VolleyballLeagueSoftwareRoute,VolleyballTournamentSoftwareRoute: VolleyballTournamentSoftwareRoute,AdminInviteTokenRoute: AdminInviteTokenRoute,BlogPost_slugRoute: BlogPost_slugRoute,ClubInviteTokenRoute: ClubInviteTokenRoute,ClubClub_slugRoute: ClubClub_slugRoute,EUidRoute: EUidRoute,EventUidRoute: EventUidRoute,HelpStreamingOverlayRoute: HelpStreamingOverlayRoute,JoinTeamTokenRoute: JoinTeamTokenRoute,LeaderboardsLeaguesRoute: LeaderboardsLeaguesRoute,LeaderboardsPlayersRoute: LeaderboardsPlayersRoute,LoginSubpageRoute: LoginSubpageRoute,OverlayTokenRoute: OverlayTokenRoute,RReferrals_codeRoute: RReferrals_codeRoute,RaceHandleRoute: RaceHandleRoute,ReturnSubpageRoute: ReturnSubpageRoute,ReturnSessionPaymentRoute: ReturnSessionPaymentRoute,SCodeRoute: SCodeRoute,SchedTokenRoute: SchedTokenRoute,SignupSignup_typeRoute: SignupSignup_typeRoute,SignupThankYouRoute: SignupThankYouRoute,StartFromGeneratorRoute: StartFromGeneratorRoute,BlogIndexRoute: BlogIndexRoute,LeaderboardsIndexRoute: LeaderboardsIndexRoute,LoginIndexRoute: LoginIndexRoute,SignupIndexRoute: SignupIndexRoute,BlogPagePage_numberRoute: BlogPagePage_numberRoute,BookCourtInviteTokenRoute: BookCourtInviteTokenRoute,EUidRegisterRoute: EUidRegisterRoute,EmbedLeaguesUidRoute: EmbedLeaguesUidRoute,EmbedRacesHandleRoute: EmbedRacesHandleRoute,EmbedTournamentsUidRoute: EmbedTournamentsUidRoute,JoinEvent_uidTokenRoute: JoinEvent_uidTokenRoute,LiveClashOfTeamsUidRoute: LiveClashOfTeamsUidRoute,LiveCotUidRoute: LiveCotUidRoute,LiveKKotc_uidRoute: LiveKKotc_uidRoute,LiveKotcKotc_uidRoute: LiveKotcKotc_uidRoute,LiveLLeague_uidRoute: LiveLLeague_uidRoute,LiveLeaderboardClub_uidRoute: LiveLeaderboardClub_uidRoute,LiveLeaguesLeague_uidRoute: LiveLeaguesLeague_uidRoute,LiveRcRyder_cup_uidRoute: LiveRcRyder_cup_uidRoute,LiveRyderCupRyder_cup_uidRoute: LiveRyderCupRyder_cup_uidRoute,LiveTTournament_uidRoute: LiveTTournament_uidRoute,LiveTournamentsTournament_uidRoute: LiveTournamentsTournament_uidRoute,PayMatchFeeTokenRoute: PayMatchFeeTokenRoute,PublicLeaguesLeague_uidApplicationsApplication_uidPayEntryFeeRoute: PublicLeaguesLeague_uidApplicationsApplication_uidPayEntryFeeRoute,PublicTournamentsTournament_uidApplicationsApplication_uidPayEntryFeeRoute: PublicTournamentsTournament_uidApplicationsApplication_uidPayEntryFeeRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)